export type Maybe<T> = T | null;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T,
> = { [_ in K]?: never };
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never;
    };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  Date: { input: number; output: number };
};

export type AcceptMeetingInput = {
  acceptedMeetingItemNames?: InputMaybe<Array<Scalars["String"]["input"]>>;
  meetingId: Scalars["ID"]["input"];
  statusDetails?: InputMaybe<Scalars["String"]["input"]>;
};

export type AcceptMeetingResponse = {
  __typename: "AcceptMeetingResponse";
  meeting: Meeting;
};

export type AcceptOrganizationInvitationInput = {
  inviteCode: Scalars["String"]["input"];
};

export type AcceptOrganizationInvitationResponse = {
  __typename: "AcceptOrganizationInvitationResponse";
  organizationMembership: OrganizationMembership;
};

export type ActivateAmeelioStaffInput = {
  id: Scalars["String"]["input"];
};

export type ActivateAmeelioStaffResponse = {
  __typename: "ActivateAmeelioStaffResponse";
  identity: AmeelioStaff;
};

export type Address = {
  __typename: "Address";
  city: Scalars["String"]["output"];
  country: Scalars["String"]["output"];
  lineOne: Scalars["String"]["output"];
  lineTwo?: Maybe<Scalars["String"]["output"]>;
  postalCode: Scalars["String"]["output"];
  province: Scalars["String"]["output"];
};

export type AdultInmatesResponse = {
  __typename: "AdultInmatesResponse";
  minorsOmitted: Scalars["Boolean"]["output"];
  results: Array<InmateSearchResult>;
};

export type AmeelioStaff = {
  __typename: "AmeelioStaff";
  active: Scalars["Boolean"]["output"];
  email: Scalars["String"]["output"];
  entitlements: Array<AmeelioStaffEntitlement>;
  firstName: Scalars["String"]["output"];
  fullName: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  lastName: Scalars["String"]["output"];
  learnRoles: Array<Scalars["String"]["output"]>;
  systemEntitlements: Array<Entitlement>;
};

export enum AmeelioStaffEntitlement {
  ManageAmeelioStaff = "MANAGE_AMEELIO_STAFF",
  ManageToolbox = "MANAGE_TOOLBOX",
  ViewCommunications = "VIEW_COMMUNICATIONS",
}

export type ApproveMessageInput = {
  messageId: Scalars["ID"]["input"];
};

export type ApproveMessageResponse = {
  __typename: "ApproveMessageResponse";
  message: Message;
};

export type ApproveSystemVisitorInput = {
  systemVisitorId: Scalars["String"]["input"];
};

export type ApproveSystemVisitorResponse = {
  __typename: "ApproveSystemVisitorResponse";
  systemVisitor: SystemUser;
};

export type ArchiveConnectionInput = {
  connectionId: Scalars["ID"]["input"];
};

export type ArchiveConnectionResponse = {
  __typename: "ArchiveConnectionResponse";
  connection: Connection;
};

export type AvailableTabletGroup = {
  __typename: "AvailableTabletGroup";
  externalId: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
  selected: Scalars["Boolean"]["output"];
};

export type BeepTabletInput = {
  facilityId: Scalars["ID"]["input"];
  tabletId: Scalars["ID"]["input"];
};

export type BeepTabletResponse = {
  __typename: "BeepTabletResponse";
  commandId: Scalars["ID"]["output"];
  success: Scalars["Boolean"]["output"];
};

export type Call = {
  __typename: "Call";
  artifactsExpireAt?: Maybe<Scalars["Date"]["output"]>;
  callLogUrl?: Maybe<Scalars["String"]["output"]>;
  callStatus: CallCallStatus;
  callType: CallType;
  duration?: Maybe<Scalars["Int"]["output"]>;
  endedAt: Scalars["Date"]["output"];
  /** @deprecated No longer supported */
  expiresAt?: Maybe<Scalars["Date"]["output"]>;
  facility: Facility;
  features: Array<CallFeature>;
  id: Scalars["ID"]["output"];
  meeting?: Maybe<Meeting>;
  messages: CallMessageConnection;
  participants: Array<CallParticipant>;
  rating?: Maybe<Scalars["Int"]["output"]>;
  recording?: Maybe<Recording>;
  screenshots: Array<Screenshot>;
  screenshotsExpireAt?: Maybe<Scalars["Date"]["output"]>;
  startedAt: Scalars["Date"]["output"];
  status: CallStatus;
  timelineEvents: Array<StaffTimelineEvent>;
  title?: Maybe<Scalars["String"]["output"]>;
  token?: Maybe<Scalars["String"]["output"]>;
  transcript?: Maybe<Transcript>;
  unlimited: Scalars["Boolean"]["output"];
  url?: Maybe<Scalars["String"]["output"]>;
};

export enum CallCallStatus {
  Cancelled = "CANCELLED",
  Ended = "ENDED",
  Live = "LIVE",
  Scheduled = "SCHEDULED",
}

export enum CallFeature {
  Logged = "LOGGED",
  Monitored = "MONITORED",
  Pictures = "PICTURES",
  Recording = "RECORDING",
}

export type CallMessage = {
  __typename: "CallMessage";
  contents: Scalars["String"]["output"];
  createdAt: Scalars["Date"]["output"];
  id: Scalars["ID"]["output"];
  sender: VisitorOrInmateOrStaff;
};

export type CallMessageConnection = {
  __typename: "CallMessageConnection";
  edges: Array<CallMessageEdge>;
  pageInfo: PageInfo;
};

export type CallMessageEdge = {
  __typename: "CallMessageEdge";
  cursor: Scalars["String"]["output"];
  node: CallMessage;
};

export type CallParticipant = {
  __typename: "CallParticipant";
  capabilities: Array<CallParticipantCapability>;
  createdAt: Scalars["Date"]["output"];
  externalId: Scalars["String"]["output"];
  fullName: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  role: ParticipantRole;
  type: ParticipantType;
};

export enum CallParticipantCapability {
  Announcements = "ANNOUNCEMENTS",
  Answers = "ANSWERS",
  Chat = "CHAT",
  Isolation = "ISOLATION",
  Questions = "QUESTIONS",
  RemoteControl = "REMOTE_CONTROL",
  Screenshare = "SCREENSHARE",
  SelfControl = "SELF_CONTROL",
}

export type CallRatingsReportType = {
  __typename: "CallRatingsReportType";
  callRating: Scalars["Int"]["output"];
  comment?: Maybe<Scalars["String"]["output"]>;
  description?: Maybe<Scalars["String"]["output"]>;
  facilityName: Scalars["String"]["output"];
  systemName: Scalars["String"]["output"];
};

export type CallResponse = {
  __typename: "CallResponse";
  call: Call;
  currentParticipant: CallParticipant;
};

export enum CallStatus {
  Active = "ACTIVE",
  Inactive = "INACTIVE",
}

export enum CallType {
  Call = "CALL",
  Room = "ROOM",
}

export type CancelMeetingInput = {
  meetingId: Scalars["ID"]["input"];
  participantComment?: InputMaybe<ParticipantComment>;
};

export type CancelMeetingResponse = {
  __typename: "CancelMeetingResponse";
  meeting: Meeting;
};

export type CancelOrTerminateMeetingsInput = {
  meetingIds: Array<Scalars["ID"]["input"]>;
  reason: Scalars["String"]["input"];
};

export type CancelOrTerminateMeetingsResponse = {
  __typename: "CancelOrTerminateMeetingsResponse";
  failures: Array<Scalars["ID"]["output"]>;
  success: Scalars["Boolean"]["output"];
  successCount: Scalars["Int"]["output"];
};

export enum Client {
  Dashboard = "DASHBOARD",
  Mobile = "MOBILE",
  Web = "WEB",
}

export type CompleteSystemStaffRegistrationResponse = {
  __typename: "CompleteSystemStaffRegistrationResponse";
  staff: Staff;
};

export type Connection = {
  __typename: "Connection";
  activeRestrictions: Array<ConnectionRestriction>;
  connectionCreatedTimelineEvent?: Maybe<ConnectionTimelineEvent>;
  contact: Correspondent;
  createdAt: Scalars["Date"]["output"];
  detectedKeywords: MessageDetectedKeywordConnection;
  features: Array<ConnectionFeature>;
  fileGallery: MessageConnection;
  id: Scalars["ID"]["output"];
  inmate: Inmate;
  kioskAvailability: Array<KioskAvailability>;
  lastInteractionAt: Scalars["Date"]["output"];
  lastMessage?: Maybe<Message>;
  lastMessageCenterActivityAt: Scalars["Date"]["output"];
  meetingAvailability: Array<MeetingAvailability>;
  meetings: Array<Meeting>;
  messages: MessageConnection;
  organizationMembership?: Maybe<OrganizationMembership>;
  paginatedMeetings: MeetingConnection;
  pendingRequestTask?: Maybe<Task>;
  privileges: Array<Privilege>;
  relationship: Scalars["String"]["output"];
  restrictions: Array<ConnectionRestriction>;
  schedules: Array<Schedule>;
  security: Array<SecurityFeature>;
  status: ConnectionStatus;
  statusChangedAt: Scalars["Date"]["output"];
  statusDetails?: Maybe<Scalars["String"]["output"]>;
  timelineEvents: ConnectionTimelineEventConnection;
  visitor: Visitor;
  visitorSystemRelationship: SystemUser;
  voiceCallAvailability: ConnectionVoiceCallAvailability;
};

export type ConnectionDetectedKeywordsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  sentAfter?: InputMaybe<Scalars["Date"]["input"]>;
  sentBefore?: InputMaybe<Scalars["Date"]["input"]>;
};

export type ConnectionFileGalleryArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type ConnectionKioskAvailabilityArgs = {
  meetingType?: InputMaybe<MeetingType>;
};

export type ConnectionMeetingAvailabilityArgs = {
  ignoreMeetingId?: InputMaybe<Scalars["ID"]["input"]>;
  meetingType?: InputMaybe<MeetingType>;
  showUntimely?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ConnectionMeetingsArgs = {
  meetingType?: InputMaybe<Array<MeetingType>>;
  status?: InputMaybe<Array<MeetingStatus>>;
};

export type ConnectionMessagesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  sentAfter?: InputMaybe<Scalars["Date"]["input"]>;
  sentBefore?: InputMaybe<Scalars["Date"]["input"]>;
};

export type ConnectionPaginatedMeetingsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  meetingType?: InputMaybe<Array<MeetingType>>;
  scheduledEndAfter?: InputMaybe<Scalars["Date"]["input"]>;
  scheduledEndBefore?: InputMaybe<Scalars["Date"]["input"]>;
  scheduledStartAfter?: InputMaybe<Scalars["Date"]["input"]>;
  scheduledStartBefore?: InputMaybe<Scalars["Date"]["input"]>;
  status?: InputMaybe<Array<MeetingStatus>>;
};

export type ConnectionTimelineEventsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
};

export enum ConnectionFeature {
  ConfidentialInPersonVisit = "CONFIDENTIAL_IN_PERSON_VISIT",
  ConfidentialVideoCall = "CONFIDENTIAL_VIDEO_CALL",
  InPersonVisit = "IN_PERSON_VISIT",
  SendMessages = "SEND_MESSAGES",
  VideoCall = "VIDEO_CALL",
  VoiceCall = "VOICE_CALL",
  Webinar = "WEBINAR",
}

export type ConnectionRestriction = {
  __typename: "ConnectionRestriction";
  connection: Connection;
  createdAt: Scalars["Date"]["output"];
  createdBy?: Maybe<StaffPosition>;
  expiresAt?: Maybe<Scalars["Date"]["output"]>;
  id: Scalars["ID"]["output"];
  isActive: Scalars["Boolean"]["output"];
  reason: Scalars["String"]["output"];
  service: FacilityService;
};

export enum ConnectionStatus {
  Active = "ACTIVE",
  Inactive = "INACTIVE",
  Pending = "PENDING",
  Rejected = "REJECTED",
}

export type ConnectionTimelineEvent = {
  __typename: "ConnectionTimelineEvent";
  connection: Connection;
  createdAt: Scalars["Date"]["output"];
  id: Scalars["ID"]["output"];
  object: ConnectionTimelineEventObject;
  verb: ConnectionTimelineEventVerb;
};

export type ConnectionTimelineEventConnection = {
  __typename: "ConnectionTimelineEventConnection";
  edges: Array<ConnectionTimelineEventEdge>;
  pageInfo: PageInfo;
};

export type ConnectionTimelineEventEdge = {
  __typename: "ConnectionTimelineEventEdge";
  cursor: Scalars["String"]["output"];
  node: ConnectionTimelineEvent;
};

export type ConnectionTimelineEventObject =
  Connection | ConnectionRestriction | Meeting | Message;

export enum ConnectionTimelineEventVerb {
  Create = "CREATE",
  Modify = "MODIFY",
}

export type ConnectionVoiceCallAvailability = {
  __typename: "ConnectionVoiceCallAvailability";
  currentSlot?: Maybe<Interval>;
  currentSlotPrivacyLevels?: Maybe<Array<PrivacyLevel>>;
  nextSlot?: Maybe<Interval>;
  remainingDuration: Scalars["Int"]["output"];
  remainingTimeQuota?: Maybe<Scalars["Int"]["output"]>;
};

export enum ContactType {
  Educational = "EDUCATIONAL",
  Healthcare = "HEALTHCARE",
  Legal = "LEGAL",
  Other = "OTHER",
  Public = "PUBLIC",
}

export type Correspondent = {
  availableUploadTypes: Array<MessageType>;
  canReceiveVoiceCalls: Scalars["Boolean"]["output"];
  connections: Array<Connection>;
  correspondentFeatures: Array<CorrespondentFeature>;
  firstName: Scalars["String"]["output"];
  fullName: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  initials: Scalars["String"]["output"];
  languagePreference: Language;
  lastName: Scalars["String"]["output"];
  malanId: Scalars["ID"]["output"];
  meetings: MeetingConnection;
  notificationEvents: NotificationEventConnection;
  unavailableUntil?: Maybe<Scalars["Date"]["output"]>;
};

export type CorrespondentCanReceiveVoiceCallsArgs = {
  systemId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type CorrespondentConnectionsArgs = {
  facilityId?: InputMaybe<Scalars["ID"]["input"]>;
  organizationId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type CorrespondentMeetingsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  facilityId?: InputMaybe<Scalars["ID"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  meetingType?: InputMaybe<Array<MeetingType>>;
  scheduledEndAfter?: InputMaybe<Scalars["Date"]["input"]>;
  scheduledEndBefore?: InputMaybe<Scalars["Date"]["input"]>;
  scheduledStartAfter?: InputMaybe<Scalars["Date"]["input"]>;
  scheduledStartBefore?: InputMaybe<Scalars["Date"]["input"]>;
  status?: InputMaybe<Array<MeetingStatus>>;
};

export type CorrespondentNotificationEventsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
};

export enum CorrespondentFeature {
  MakePhoneCalls = "MAKE_PHONE_CALLS",
  MakeVoiceCalls = "MAKE_VOICE_CALLS",
  RequestConnections = "REQUEST_CONNECTIONS",
  ScheduleMeetings = "SCHEDULE_MEETINGS",
}

export type CountGroup = {
  __typename: "CountGroup";
  count: Scalars["Int"]["output"];
  group: Scalars["String"]["output"];
};

export type CreateCallReportInput = {
  callId?: InputMaybe<Scalars["ID"]["input"]>;
  comment?: InputMaybe<Scalars["String"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  meetingId?: InputMaybe<Scalars["ID"]["input"]>;
  rating: Scalars["Int"]["input"];
};

export type CreateCallReportResponse = {
  __typename: "CreateCallReportResponse";
  call: Call;
  meeting: Meeting;
};

export type CreateConnectionRestrictionInput = {
  connectionId: Scalars["ID"]["input"];
  expiresAt?: InputMaybe<Scalars["Date"]["input"]>;
  reason: Scalars["String"]["input"];
  service: FacilityService;
};

export type CreateConnectionRestrictionResponse = {
  __typename: "CreateConnectionRestrictionResponse";
  connectionRestriction: ConnectionRestriction;
};

export type CreateConnectionRestrictionsInput = {
  connectionIds: Array<Scalars["ID"]["input"]>;
  expiresAt?: InputMaybe<Scalars["Date"]["input"]>;
  reason: Scalars["String"]["input"];
  services: Array<FacilityService>;
};

export type CreateConnectionRestrictionsResponse = {
  __typename: "CreateConnectionRestrictionsResponse";
  errors?: Maybe<Array<Scalars["String"]["output"]>>;
  restrictions: Array<ConnectionRestriction>;
};

export type CreateFacilityApprovedPhoneInput = {
  description: Scalars["String"]["input"];
  facilityId: Scalars["ID"]["input"];
  name: Scalars["String"]["input"];
  number: Scalars["String"]["input"];
  privacyLevel: PrivacyLevel;
};

export type CreateFacilityApprovedPhoneResponse = {
  __typename: "CreateFacilityApprovedPhoneResponse";
  facilityApprovedPhone: FacilityApprovedPhone;
};

export type CreateFacilityInput = {
  country: Scalars["String"]["input"];
  name: Scalars["String"]["input"];
  province: Scalars["String"]["input"];
  publicId: Scalars["String"]["input"];
  state: UsState;
  systemId: Scalars["String"]["input"];
  timezone: Scalars["String"]["input"];
  type: FacilityType;
};

export type CreateFacilityResponse = {
  __typename: "CreateFacilityResponse";
  facility: Facility;
};

export type CreateGroupInput = {
  description: Scalars["String"]["input"];
  facilityId: Scalars["ID"]["input"];
  name: Scalars["String"]["input"];
};

export type CreateGroupResponse = {
  __typename: "CreateGroupResponse";
  group: Group;
};

export type CreateInstantReplyMessageInput = {
  content: InstantReply;
  meetingId: Scalars["ID"]["input"];
};

export type CreateInstantReplyMessageResponse = {
  __typename: "CreateInstantReplyMessageResponse";
  event: ConnectionTimelineEvent;
  message: Message;
};

export type CreateKioskInput = {
  capacity: Scalars["Int"]["input"];
  enabled: Scalars["Boolean"]["input"];
  facilityId: Scalars["ID"]["input"];
  name: Scalars["String"]["input"];
};

export type CreateKioskResponse = {
  __typename: "CreateKioskResponse";
  kiosk: Kiosk;
};

export type CreateLearnInstanceInput = {
  accessToken: Scalars["String"]["input"];
  accountId: Scalars["String"]["input"];
  autoEnrollEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  baseUrl: Scalars["String"]["input"];
  systemId: Scalars["ID"]["input"];
};

export type CreateLearnInstanceResponse = {
  __typename: "CreateLearnInstanceResponse";
  learnInstance: LearnInstance;
};

export type CreateLocalMessageKeywordInput = {
  category: MessageKeywordCategory;
  description: Scalars["String"]["input"];
  facilityId: Scalars["ID"]["input"];
  name: Scalars["String"]["input"];
  spellings: Array<Scalars["String"]["input"]>;
};

export type CreateLocalMessageKeywordResponse = {
  __typename: "CreateLocalMessageKeywordResponse";
  messageKeyword: MessageKeyword;
};

export type CreateMeetingItemInput = {
  description?: InputMaybe<Scalars["String"]["input"]>;
  name: Scalars["String"]["input"];
};

export type CreateMessageInput = {
  connectionId: Scalars["ID"]["input"];
  content?: InputMaybe<Scalars["String"]["input"]>;
  fileKey?: InputMaybe<Scalars["String"]["input"]>;
  fileName?: InputMaybe<Scalars["String"]["input"]>;
};

export type CreateMessageResponse = {
  __typename: "CreateMessageResponse";
  event: ConnectionTimelineEvent;
  message: Message;
};

export type CreateOrganizationInput = {
  addressLineOne: Scalars["String"]["input"];
  addressLineTwo?: InputMaybe<Scalars["String"]["input"]>;
  city: Scalars["String"]["input"];
  country: Scalars["String"]["input"];
  description: Scalars["String"]["input"];
  ein?: InputMaybe<Scalars["String"]["input"]>;
  email: Scalars["String"]["input"];
  legalName?: InputMaybe<Scalars["String"]["input"]>;
  logoImageKey?: InputMaybe<Scalars["String"]["input"]>;
  missionStatement?: InputMaybe<Scalars["String"]["input"]>;
  name: Scalars["String"]["input"];
  phone: Scalars["String"]["input"];
  postal: Scalars["String"]["input"];
  province: Scalars["String"]["input"];
  state: UsState;
  type: OrganizationType;
  websiteLink?: InputMaybe<Scalars["String"]["input"]>;
};

export type CreateOrganizationInvitationInput = {
  email: Scalars["String"]["input"];
  organizationId: Scalars["ID"]["input"];
  role: OrganizationMembershipRole;
};

export type CreateOrganizationInvitationResponse = {
  __typename: "CreateOrganizationInvitationResponse";
  organizationInvitation: OrganizationInvitation;
};

export type CreateOrganizationResponse = {
  __typename: "CreateOrganizationResponse";
  organization: Organization;
};

export type CreatePendingConnectionInput = {
  inmateId: Scalars["ID"]["input"];
  relationship: Scalars["String"]["input"];
};

export type CreatePendingConnectionResponse = {
  __typename: "CreatePendingConnectionResponse";
  connection: Connection;
};

export type CreatePendingProfessionalConnectionInput = {
  inmateId: Scalars["ID"]["input"];
  organizationMembershipId: Scalars["ID"]["input"];
};

export type CreatePendingProfessionalConnectionResponse = {
  __typename: "CreatePendingProfessionalConnectionResponse";
  connection: Connection;
};

export type CreatePrivilegeInput = {
  amount?: InputMaybe<Scalars["Int"]["input"]>;
  contactTypes: Array<PrivilegeContactType>;
  meetingTypes: Array<MeetingType>;
  period?: InputMaybe<PrivilegePeriod>;
  privilegeLevelId: Scalars["ID"]["input"];
  unit?: InputMaybe<PrivilegeUnit>;
  weekBeginsOn?: InputMaybe<Scalars["Int"]["input"]>;
};

export type CreatePrivilegeLevelInput = {
  facilityId: Scalars["ID"]["input"];
  name: Scalars["String"]["input"];
};

export type CreatePrivilegeLevelResponse = {
  __typename: "CreatePrivilegeLevelResponse";
  privilegeLevel: PrivilegeLevel;
};

export type CreatePrivilegeResponse = {
  __typename: "CreatePrivilegeResponse";
  privilege: Privilege;
};

export type CreatePstnConnectionInput = {
  firstName: Scalars["String"]["input"];
  inmateId: Scalars["ID"]["input"];
  lastName?: InputMaybe<Scalars["String"]["input"]>;
  phone: Scalars["String"]["input"];
  relationship: Scalars["String"]["input"];
};

export type CreatePstnConnectionResponse = {
  __typename: "CreatePstnConnectionResponse";
  connection: Connection;
};

export type CreateRecordingInput = {
  meetingId: Scalars["ID"]["input"];
};

export type CreateRecordingResponse = {
  __typename: "CreateRecordingResponse";
  call: Call;
  success: Scalars["Boolean"]["output"];
};

export type CreateScheduleInput = {
  contactTypes?: InputMaybe<Array<ContactType>>;
  endsOn?: InputMaybe<Scalars["String"]["input"]>;
  facilityId: Scalars["ID"]["input"];
  groupIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  kioskIds: Array<Scalars["ID"]["input"]>;
  meetingSlots: Array<Slot>;
  meetingTypes?: InputMaybe<Array<MeetingType>>;
  name: Scalars["String"]["input"];
  privacyLevels?: InputMaybe<Array<PrivacyLevel>>;
  privilegeLevelIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  startsOn?: InputMaybe<Scalars["String"]["input"]>;
};

export type CreateScheduleResponse = {
  __typename: "CreateScheduleResponse";
  schedule: Schedule;
};

export type CreateScheduledMeetingInput = {
  connectionIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  inmateIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  isPrivilegeException?: InputMaybe<Scalars["Boolean"]["input"]>;
  kioskId?: InputMaybe<Scalars["ID"]["input"]>;
  meetingItems?: InputMaybe<Array<CreateMeetingItemInput>>;
  meetingType: MeetingType;
  notes?: InputMaybe<Scalars["String"]["input"]>;
  scheduledEnd: Scalars["Date"]["input"];
  scheduledStart: Scalars["Date"]["input"];
  title?: InputMaybe<Scalars["String"]["input"]>;
  unregisteredGuests?: InputMaybe<Array<Scalars["String"]["input"]>>;
  visitorIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type CreateScheduledMeetingResponse = {
  __typename: "CreateScheduledMeetingResponse";
  meeting: Meeting;
};

export type CreateStaffInput = {
  email: Scalars["String"]["input"];
  entitlements: Array<Entitlement>;
  facilityIds: Array<Scalars["ID"]["input"]>;
  firstName: Scalars["String"]["input"];
  language?: InputMaybe<Language>;
  lastName?: InputMaybe<Scalars["String"]["input"]>;
  phone?: InputMaybe<Scalars["String"]["input"]>;
  systemId: Scalars["ID"]["input"];
};

export type CreateStaffResponse = {
  __typename: "CreateStaffResponse";
  staff: Staff;
};

export type CreateSurveyImpressionInput = {
  client: Client;
  code: Scalars["String"]["input"];
  id: Scalars["ID"]["input"];
  language: Language;
  screen: Scalars["String"]["input"];
  version: Scalars["Int"]["input"];
};

export type CreateSurveyImpressionResponse = {
  __typename: "CreateSurveyImpressionResponse";
  success: Scalars["Boolean"]["output"];
};

export type CreateSurveyResponseInput = {
  answers: Array<SurveyAnswer>;
  surveyImpressionId: Scalars["ID"]["input"];
};

export type CreateSurveyResponseResponse = {
  __typename: "CreateSurveyResponseResponse";
  success: Scalars["Boolean"]["output"];
};

export type CreateSystemAppInput = {
  ameelio?: InputMaybe<Scalars["Boolean"]["input"]>;
  description: Scalars["String"]["input"];
  origin: Array<Scalars["String"]["input"]>;
  systemId: Scalars["String"]["input"];
};

export type CreateSystemAppResponse = {
  __typename: "CreateSystemAppResponse";
  clientSecret: Scalars["String"]["output"];
  systemApp: SystemApp;
};

export type CreateSystemInput = {
  allowInmatePasswordReset?: InputMaybe<Scalars["Boolean"]["input"]>;
  ameelioStaffPassword: Scalars["String"]["input"];
  code: Scalars["String"]["input"];
  dataRetention?: InputMaybe<Scalars["Int"]["input"]>;
  hasCallTranscripts: Scalars["Boolean"]["input"];
  hasTablets?: InputMaybe<Scalars["Boolean"]["input"]>;
  maxPasswordAgeDays?: InputMaybe<Scalars["Int"]["input"]>;
  name: Scalars["String"]["input"];
  recordingRetention: Scalars["Int"]["input"];
  visitorReapprovalDays?: InputMaybe<Scalars["Int"]["input"]>;
};

export type CreateSystemResponse = {
  __typename: "CreateSystemResponse";
  system: System;
};

export type CreateTestCallResponse = {
  __typename: "CreateTestCallResponse";
  callId: Scalars["ID"]["output"];
  token: Scalars["String"]["output"];
  url: Scalars["String"]["output"];
};

export type CreateTranscriptInput = {
  callId: Scalars["ID"]["input"];
};

export type CreateTranscriptResponse = {
  __typename: "CreateTranscriptResponse";
  success: Scalars["Boolean"]["output"];
};

export type CreateVisitorIdentityInput = {
  dateOfBirth: Scalars["String"]["input"];
  documentType: IdDocumentType;
  firstName: Scalars["String"]["input"];
  imageOneKey: Scalars["String"]["input"];
  imageThreeKey: Scalars["String"]["input"];
  imageTwoKey: Scalars["String"]["input"];
  lastName?: InputMaybe<Scalars["String"]["input"]>;
};

export type CreateVisitorIdentityResponse = {
  __typename: "CreateVisitorIdentityResponse";
  visitor: Visitor;
};

export type CreateVisitorInput = {
  dateOfBirth: Scalars["String"]["input"];
  email: Scalars["String"]["input"];
  firstName: Scalars["String"]["input"];
  lastName?: InputMaybe<Scalars["String"]["input"]>;
  password: Scalars["String"]["input"];
  passwordConfirmation: Scalars["String"]["input"];
  phone?: InputMaybe<Scalars["String"]["input"]>;
};

export type CreateVisitorResponse = {
  __typename: "CreateVisitorResponse";
  authToken: Scalars["String"]["output"];
};

export type CreateVisitorVoiceCallInput = {
  deviceId?: InputMaybe<Scalars["ID"]["input"]>;
  facilityId: Scalars["ID"]["input"];
  visitorId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type CreateVisitorVoiceCallResponse = {
  __typename: "CreateVisitorVoiceCallResponse";
  participantUrl?: Maybe<Scalars["String"]["output"]>;
};

export type CreateVoiceCallInput = {
  connectionId: Scalars["ID"]["input"];
};

export type CreateVoiceCallResponse = {
  __typename: "CreateVoiceCallResponse";
  event: ConnectionTimelineEvent;
  meeting: Meeting;
};

export type CredentialsInput = {
  password: Scalars["String"]["input"];
  userType: UserType;
  username: Scalars["String"]["input"];
};

export type DeactivateAmeelioStaffInput = {
  id: Scalars["String"]["input"];
};

export type DeactivateAmeelioStaffResponse = {
  __typename: "DeactivateAmeelioStaffResponse";
  identity: AmeelioStaff;
};

export type DeactivateConnectionInput = {
  connectionId: Scalars["ID"]["input"];
};

export type DeactivateConnectionResponse = {
  __typename: "DeactivateConnectionResponse";
  success: Scalars["Boolean"]["output"];
};

export type DeactivateFacilityInput = {
  facilityId: Scalars["ID"]["input"];
};

export type DeactivateFacilityResponse = {
  __typename: "DeactivateFacilityResponse";
  success: Scalars["Boolean"]["output"];
};

export type DeactivateLocalMessageKeywordInput = {
  messageKeywordId: Scalars["ID"]["input"];
};

export type DeactivateLocalMessageKeywordResponse = {
  __typename: "DeactivateLocalMessageKeywordResponse";
  messageKeyword: MessageKeyword;
};

export type DeactivateOrganizationInput = {
  organizationId: Scalars["ID"]["input"];
};

export type DeactivateOrganizationMembershipInput = {
  organizationMembershipId: Scalars["ID"]["input"];
};

export type DeactivateOrganizationMembershipResponse = {
  __typename: "DeactivateOrganizationMembershipResponse";
  organizationMembership: OrganizationMembership;
};

export type DeactivateOrganizationResponse = {
  __typename: "DeactivateOrganizationResponse";
  success: Scalars["Boolean"]["output"];
};

export type DeactivateStaffInput = {
  staffId: Scalars["ID"]["input"];
  systemId: Scalars["ID"]["input"];
};

export type DeactivateStaffPositionInput = {
  staffPositionId: Scalars["ID"]["input"];
};

export type DeactivateStaffPositionResponse = {
  __typename: "DeactivateStaffPositionResponse";
  staffPosition: StaffPosition;
};

export type DeactivateStaffResponse = {
  __typename: "DeactivateStaffResponse";
  staff: Staff;
};

export type DeclineVoiceCallInput = {
  callId?: InputMaybe<Scalars["ID"]["input"]>;
  meetingId?: InputMaybe<Scalars["ID"]["input"]>;
  reason?: InputMaybe<InstantReply>;
};

export type DeclineVoiceCallResponse = {
  __typename: "DeclineVoiceCallResponse";
  meeting?: Maybe<Meeting>;
  success: Scalars["Boolean"]["output"];
};

export type DeleteGroupInput = {
  groupId: Scalars["ID"]["input"];
};

export type DeleteGroupResponse = {
  __typename: "DeleteGroupResponse";
  success: Scalars["Boolean"]["output"];
};

export type DeletePrivilegeInput = {
  privilegeId: Scalars["ID"]["input"];
};

export type DeletePrivilegeLevelInput = {
  privilegeLevelId: Scalars["ID"]["input"];
};

export type DeletePrivilegeLevelResponse = {
  __typename: "DeletePrivilegeLevelResponse";
  success: Scalars["Boolean"]["output"];
};

export type DeletePrivilegeResponse = {
  __typename: "DeletePrivilegeResponse";
  success: Scalars["Boolean"]["output"];
};

export type DeleteScheduleInput = {
  scheduleId: Scalars["ID"]["input"];
};

export type DeleteScheduleResponse = {
  __typename: "DeleteScheduleResponse";
  success: Scalars["Boolean"]["output"];
};

export type DeleteVisitorInput = {
  visitorId: Scalars["ID"]["input"];
};

export type DeleteVisitorResponse = {
  __typename: "DeleteVisitorResponse";
  scheduledDeletionAt: Scalars["Date"]["output"];
};

export type Device = {
  __typename: "Device";
  active: Scalars["Boolean"]["output"];
  appVersion?: Maybe<Scalars["String"]["output"]>;
  createdAt: Scalars["Date"]["output"];
  deviceId?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  malanUserId: Scalars["ID"]["output"];
  type: DeviceType;
  updatedAt: Scalars["Date"]["output"];
  visitor: Visitor;
};

export enum DeviceRegistrationStatus {
  NeedsRegistration = "NEEDS_REGISTRATION",
  NotRequired = "NOT_REQUIRED",
  PendingApproval = "PENDING_APPROVAL",
  Registered = "REGISTERED",
}

export enum DeviceType {
  Android = "ANDROID",
  Ios = "IOS",
}

export type DownloadScreenshotsInput = {
  meetingId: Scalars["ID"]["input"];
};

export type DownloadScreenshotsResponse = {
  __typename: "DownloadScreenshotsResponse";
  url: Scalars["String"]["output"];
};

export type DownloadTranscriptInput = {
  meetingId: Scalars["ID"]["input"];
};

export type DownloadTranscriptResponse = {
  __typename: "DownloadTranscriptResponse";
  url: Scalars["String"]["output"];
};

export type EnableInmatePasswordResetInput = {
  inmateId: Scalars["ID"]["input"];
};

export type EnableInmatePasswordResetResponse = {
  __typename: "EnableInmatePasswordResetResponse";
  inmate: Inmate;
};

export type EndVoiceCallInput = {
  callId?: InputMaybe<Scalars["ID"]["input"]>;
  meetingId?: InputMaybe<Scalars["ID"]["input"]>;
  status?: InputMaybe<MeetingStatus>;
  userInitiated?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type EndVoiceCallResponse = {
  __typename: "EndVoiceCallResponse";
  meeting?: Maybe<Meeting>;
  success: Scalars["Boolean"]["output"];
};

export enum Entitlement {
  ManageFacility = "MANAGE_FACILITY",
  ManageInmates = "MANAGE_INMATES",
  ManageMeetings = "MANAGE_MEETINGS",
  ManageStaff = "MANAGE_STAFF",
  ManageTablets = "MANAGE_TABLETS",
  ManageVisitors = "MANAGE_VISITORS",
  /** @deprecated Use `MANAGE_VISITORS` and `MANAGE_MEETINGS` instead */
  ManageVisitorsAndMeetings = "MANAGE_VISITORS_AND_MEETINGS",
  MonitorLiveCalls = "MONITOR_LIVE_CALLS",
  ReviewEmessages = "REVIEW_EMESSAGES",
  ReviewRecordings = "REVIEW_RECORDINGS",
  ReviewScreenshots = "REVIEW_SCREENSHOTS",
  /** @deprecated Use `MANAGE_INMATES` instead */
  UploadSystemRoster = "UPLOAD_SYSTEM_ROSTER",
}

export type ExtendSessionResponse = {
  __typename: "ExtendSessionResponse";
  expiresAt: Scalars["String"]["output"];
  remainingDuration: Scalars["Int"]["output"];
  sessionId: Scalars["String"]["output"];
};

export type Facility = {
  __typename: "Facility";
  approvedPhones: Array<FacilityApprovedPhone>;
  availableKiosks: Array<Kiosk>;
  connectedOrganizations: Array<Organization>;
  country: Scalars["String"]["output"];
  defaultCallQuota: Scalars["Int"]["output"];
  defaultEmessageDelay: Scalars["Int"]["output"];
  defaultNeedsMonitor: Scalars["Boolean"]["output"];
  defaultVisitQuota: Scalars["Int"]["output"];
  defaultVoiceCallTimeQuota: Scalars["Int"]["output"];
  detectedKeywords: MessageDetectedKeywordConnection;
  email: Scalars["String"]["output"];
  /** @deprecated No longer supported */
  facilityOrganizations: Array<FacilityOrganization>;
  features: Array<FacilityFeature>;
  groups: Array<Group>;
  hasConfidentialInPersonVisits: Scalars["Boolean"]["output"];
  hasConfidentialVideoCalls: Scalars["Boolean"]["output"];
  /** @deprecated No longer supported */
  hasMessaging: Scalars["Boolean"]["output"];
  hasSystemDeviceApproval: Scalars["Boolean"]["output"];
  hasWebinars: Scalars["Boolean"]["output"];
  id: Scalars["ID"]["output"];
  /** @deprecated Use system inmates instead */
  inmates: InmateConnection;
  keywords: Array<MessageKeyword>;
  kiosks: Array<Kiosk>;
  maxVoiceCallDuration?: Maybe<Scalars["Int"]["output"]>;
  maxVoiceCalls?: Maybe<Scalars["Int"]["output"]>;
  meetingBadgeCounts: MeetingBadgeCounts;
  meetingTranscripts: Array<TranscriptSearchResult>;
  meetings: MeetingConnection;
  minimumAgeIdRequired: Scalars["Int"]["output"];
  name: Scalars["String"]["output"];
  newInmates: InmateConnection;
  newVisitors: VisitorConnection;
  pendingConnectionRequests: Array<Connection>;
  pendingConnectionRequestsCounts: PendingConnectionRequestsCounts;
  pendingMessages: MessageConnection;
  pendingTasks: Array<Task>;
  pendingTasksCounts: PendingTasksCounts;
  personalVideoCutoff: Scalars["Int"]["output"];
  personalVideoWindow: Scalars["Int"]["output"];
  personalVisitCutoff: Scalars["Int"]["output"];
  personalVisitWindow: Scalars["Int"]["output"];
  phone: Scalars["String"]["output"];
  phoneCalls: PhoneCallConnection;
  policyLink?: Maybe<Scalars["String"]["output"]>;
  privilegeLevels: Array<PrivilegeLevel>;
  providerVideoCutoff: Scalars["Int"]["output"];
  providerVideoWindow: Scalars["Int"]["output"];
  providerVisitCutoff: Scalars["Int"]["output"];
  providerVisitWindow: Scalars["Int"]["output"];
  province: Scalars["String"]["output"];
  publicId: Scalars["String"]["output"];
  schedules: Array<Schedule>;
  staffPositions: Array<StaffPosition>;
  state: UsState;
  system: System;
  tabletGroups: Array<TabletGroup>;
  tablets: TabletPage;
  timezone: Scalars["String"]["output"];
  twilioPhoneNumber?: Maybe<Scalars["String"]["output"]>;
  type: FacilityType;
  unaccompaniedVisitAge: Scalars["Int"]["output"];
  videoNeedsApproval: Scalars["Boolean"]["output"];
  videoQuotaResetDay: Scalars["Int"]["output"];
  virtualBackgrounds: VirtualBackground;
  visitGuestRegistrationRequired: Scalars["Boolean"]["output"];
  visitNeedsApproval: Scalars["Boolean"]["output"];
  visitQuotaResetDay: Scalars["Int"]["output"];
  visitationFormLink?: Maybe<Scalars["String"]["output"]>;
  visitors: VisitorConnection;
  /** @deprecated No longer supported */
  voiceCallPrivacyLevel: PrivacyLevel;
  voiceCallResetTime: Scalars["Int"]["output"];
  webinarAvailability: Array<WebinarAvailability>;
};

export type FacilityAvailableKiosksArgs = {
  capacity?: InputMaybe<Scalars["Int"]["input"]>;
  end: Scalars["Date"]["input"];
  start: Scalars["Date"]["input"];
};

export type FacilityDetectedKeywordsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  sentAfter?: InputMaybe<Scalars["Date"]["input"]>;
  sentBefore?: InputMaybe<Scalars["Date"]["input"]>;
};

export type FacilityFacilityOrganizationsArgs = {
  status?: InputMaybe<FacilityOrganizationStatus>;
};

export type FacilityInmatesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  nameOrIdentification?: InputMaybe<Scalars["String"]["input"]>;
};

export type FacilityMeetingTranscriptsArgs = {
  first?: InputMaybe<Scalars["Int"]["input"]>;
  inmateName?: InputMaybe<Scalars["String"]["input"]>;
  query?: InputMaybe<Scalars["String"]["input"]>;
  scheduledStartAfter?: InputMaybe<Scalars["Date"]["input"]>;
  scheduledStartBefore?: InputMaybe<Scalars["Date"]["input"]>;
};

export type FacilityMeetingsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  asc?: InputMaybe<Scalars["Boolean"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  confidential?: InputMaybe<Scalars["Boolean"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  group?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  meetingType?: InputMaybe<Array<MeetingType>>;
  scheduledStartAfter?: InputMaybe<Scalars["Date"]["input"]>;
  scheduledStartAfterNew?: InputMaybe<Scalars["String"]["input"]>;
  scheduledStartBefore?: InputMaybe<Scalars["Date"]["input"]>;
  scheduledStartBeforeNew?: InputMaybe<Scalars["String"]["input"]>;
  status?: InputMaybe<Array<MeetingStatus>>;
};

export type FacilityNewInmatesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  groupId?: InputMaybe<Scalars["String"]["input"]>;
  inmateIdentification?: InputMaybe<Scalars["String"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  privilegeLevelId?: InputMaybe<Scalars["String"]["input"]>;
};

export type FacilityNewVisitorsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  email?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  type?: InputMaybe<VisitorType>;
};

export type FacilityPendingTasksArgs = {
  contactType?: InputMaybe<ContactType>;
  residentId?: InputMaybe<Scalars["ID"]["input"]>;
  types?: InputMaybe<Array<TaskType>>;
};

export type FacilityPhoneCallsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  asc?: InputMaybe<Scalars["Boolean"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  scheduledStartAfter?: InputMaybe<Scalars["Date"]["input"]>;
  scheduledStartBefore?: InputMaybe<Scalars["Date"]["input"]>;
};

export type FacilitySchedulesArgs = {
  group?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  meetingType?: InputMaybe<Array<MeetingType>>;
  privacyLevel?: InputMaybe<Array<PrivacyLevel>>;
};

export type FacilityStaffPositionsArgs = {
  isActive?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type FacilityTabletsArgs = {
  groupId?: InputMaybe<Scalars["String"]["input"]>;
  limit?: Scalars["Int"]["input"];
  offset?: Scalars["Int"]["input"];
  search?: InputMaybe<Scalars["String"]["input"]>;
};

export type FacilityVisitorsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  type?: InputMaybe<VisitorType>;
};

export type FacilityApprovedPhone = {
  __typename: "FacilityApprovedPhone";
  active: Scalars["Boolean"]["output"];
  description: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
  number: Scalars["String"]["output"];
  security: Array<SecurityFeature>;
};

export enum FacilityFeature {
  ConfidentialInPersonVisit = "CONFIDENTIAL_IN_PERSON_VISIT",
  ConfidentialScreenshots = "CONFIDENTIAL_SCREENSHOTS",
  ConfidentialVideoCall = "CONFIDENTIAL_VIDEO_CALL",
  DeviceApproval = "DEVICE_APPROVAL",
  Emessaging = "EMESSAGING",
  InPersonVisit = "IN_PERSON_VISIT",
  PhoneCall = "PHONE_CALL",
  PrivilegeLevels = "PRIVILEGE_LEVELS",
  PstnCall = "PSTN_CALL",
  VideoCall = "VIDEO_CALL",
  VoiceCall = "VOICE_CALL",
  Webinar = "WEBINAR",
}

export type FacilityOrganization = {
  __typename: "FacilityOrganization";
  facility: Facility;
  id: Scalars["ID"]["output"];
  organization: Organization;
  status: FacilityOrganizationStatus;
  statusChangedAt: Scalars["Date"]["output"];
  statusDetails?: Maybe<Scalars["String"]["output"]>;
};

export enum FacilityOrganizationStatus {
  Active = "ACTIVE",
  Inactive = "INACTIVE",
  Pending = "PENDING",
}

export enum FacilityService {
  Emessaging = "EMESSAGING",
  InPersonVisit = "IN_PERSON_VISIT",
  VideoCall = "VIDEO_CALL",
  VoiceCall = "VOICE_CALL",
  Webinar = "WEBINAR",
}

export enum FacilityType {
  Federal = "FEDERAL",
  Ice = "ICE",
  Jail = "JAIL",
  Juv = "JUV",
  State = "STATE",
}

export type Group = {
  __typename: "Group";
  description: Scalars["String"]["output"];
  facility: Facility;
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
};

export enum IdDocumentType {
  BirthCertificate = "BIRTH_CERTIFICATE",
  Cnic = "CNIC",
  DriversLicense = "DRIVERS_LICENSE",
  IdCard = "ID_CARD",
  Other = "OTHER",
  Passport = "PASSPORT",
  Undocumented = "UNDOCUMENTED",
}

export type Inmate = Correspondent & {
  __typename: "Inmate";
  availableUploadTypes: Array<MessageType>;
  callQuota: Scalars["Int"]["output"];
  canReceiveVoiceCalls: Scalars["Boolean"]["output"];
  connections: Array<Connection>;
  correspondentFeatures: Array<CorrespondentFeature>;
  dateOfBirth: Scalars["Date"]["output"];
  enablePasswordReset: Scalars["Boolean"]["output"];
  facility: Facility;
  firstName: Scalars["String"]["output"];
  fullName: Scalars["String"]["output"];
  group: Group;
  guest?: Maybe<InmateGuest>;
  hasFilledIntakeForm: Scalars["Boolean"]["output"];
  hasSentAnyMessages: Scalars["Boolean"]["output"];
  id: Scalars["ID"]["output"];
  initials: Scalars["String"]["output"];
  inmateIdentification: Scalars["String"]["output"];
  kioskAvailability: Array<KioskAvailability>;
  languagePreference: Language;
  lastName: Scalars["String"]["output"];
  lockedPrivilegeLevel: Scalars["Boolean"]["output"];
  malanId: Scalars["ID"]["output"];
  meetingAvailability: Array<MeetingAvailability>;
  meetings: MeetingConnection;
  needsApproval: Scalars["Boolean"]["output"];
  needsMonitor: Scalars["Boolean"]["output"];
  notificationEvents: NotificationEventConnection;
  privilegeLevel: PrivilegeLevel;
  remainingVoiceCallDurationResetTime?: Maybe<Scalars["Date"]["output"]>;
  /**
   * Superseded by Connection.voiceCallAvailability.remainingTimeQuota, but
   * connect-dashboard still queries this field directly, so it is kept
   * (not marked @deprecated) until that caller migrates.
   */
  remainingVoiceCallTimeQuota?: Maybe<Scalars["Int"]["output"]>;
  surveyActivity: Array<Maybe<SurveyActivity>>;
  timelineEvents: Array<StaffTimelineEvent>;
  unavailableUntil?: Maybe<Scalars["Date"]["output"]>;
  unreadMessageCount: Scalars["Int"]["output"];
  visitQuota: Scalars["Int"]["output"];
  voiceCallTimeQuota: Scalars["Int"]["output"];
};

export type InmateCanReceiveVoiceCallsArgs = {
  systemId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type InmateConnectionsArgs = {
  facilityId?: InputMaybe<Scalars["ID"]["input"]>;
  organizationId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type InmateGuestArgs = {
  email: Scalars["String"]["input"];
};

export type InmateKioskAvailabilityArgs = {
  meetingType?: InputMaybe<MeetingType>;
};

export type InmateMeetingAvailabilityArgs = {
  ignoreMeetingId?: InputMaybe<Scalars["ID"]["input"]>;
  meetingType?: InputMaybe<MeetingType>;
  showUntimely?: InputMaybe<Scalars["Boolean"]["input"]>;
  visitorIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type InmateMeetingsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  facilityId?: InputMaybe<Scalars["ID"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  meetingType?: InputMaybe<Array<MeetingType>>;
  scheduledEndAfter?: InputMaybe<Scalars["Date"]["input"]>;
  scheduledEndBefore?: InputMaybe<Scalars["Date"]["input"]>;
  scheduledStartAfter?: InputMaybe<Scalars["Date"]["input"]>;
  scheduledStartBefore?: InputMaybe<Scalars["Date"]["input"]>;
  status?: InputMaybe<Array<MeetingStatus>>;
};

export type InmateNotificationEventsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type InmateConnection = {
  __typename: "InmateConnection";
  count: Scalars["Int"]["output"];
  edges: Array<InmateEdge>;
  pageInfo: PageInfo;
};

export type InmateEdge = {
  __typename: "InmateEdge";
  cursor: Scalars["String"]["output"];
  node: Inmate;
};

export type InmateGuest = {
  __typename: "InmateGuest";
  connectionId: Scalars["ID"]["output"];
  email: Scalars["String"]["output"];
  firstName: Scalars["String"]["output"];
  fullName: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  lastName: Scalars["String"]["output"];
};

export type InmatePasswordResetEligibilityResponse = {
  __typename: "InmatePasswordResetEligibilityResponse";
  enabled: Scalars["Boolean"]["output"];
};

export type InmateSearchResult = {
  __typename: "InmateSearchResult";
  dateOfBirth: Scalars["Date"]["output"];
  facility: Facility;
  firstName: Scalars["String"]["output"];
  fullName: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  initials: Scalars["String"]["output"];
  inmateIdentification: Scalars["String"]["output"];
  lastName: Scalars["String"]["output"];
};

export type InmateSearchResultConnection = {
  __typename: "InmateSearchResultConnection";
  count: Scalars["Int"]["output"];
  edges: Array<InmateSearchResultEdge>;
  pageInfo: PageInfo;
};

export type InmateSearchResultEdge = {
  __typename: "InmateSearchResultEdge";
  cursor: Scalars["String"]["output"];
  node: InmateSearchResult;
};

export enum InstantReply {
  CallBackFiveMinutes = "CALL_BACK_FIVE_MINUTES",
  CallBackNow = "CALL_BACK_NOW",
  CallBackTwoMinutes = "CALL_BACK_TWO_MINUTES",
  CantTalkNow = "CANT_TALK_NOW",
}

export type Interval = {
  __typename: "Interval";
  duration?: Maybe<Scalars["Int"]["output"]>;
  endAt: Scalars["Date"]["output"];
  seconds?: Maybe<Scalars["Int"]["output"]>;
  startAt: Scalars["Date"]["output"];
};

export type Kiosk = {
  __typename: "Kiosk";
  capacity: Scalars["Int"]["output"];
  createdAt: Scalars["Date"]["output"];
  enabled: Scalars["Boolean"]["output"];
  facility: Facility;
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
};

export type KioskAvailability = {
  __typename: "KioskAvailability";
  interval: Interval;
  kiosk: Kiosk;
};

export enum Language {
  En = "EN",
  Es = "ES",
  It = "IT",
}

export type LearnInstance = {
  __typename: "LearnInstance";
  baseUrl: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  system: System;
};

export type LeaveMeetingInput = {
  meetingId: Scalars["ID"]["input"];
};

export type LeaveMeetingResponse = {
  __typename: "LeaveMeetingResponse";
  success: Scalars["Boolean"]["output"];
};

export type LoginInput = {
  password: Scalars["String"]["input"];
  userType: UserType;
  username: Scalars["String"]["input"];
};

export type LoginResponse = {
  __typename: "LoginResponse";
  authToken: Scalars["String"]["output"];
  expiresAt: Scalars["String"]["output"];
  remainingDuration: Scalars["Int"]["output"];
  sessionId: Scalars["String"]["output"];
};

export type LogoutInput = {
  deviceId?: InputMaybe<Scalars["String"]["input"]>;
};

export type LogoutResponse = {
  __typename: "LogoutResponse";
  success: Scalars["Boolean"]["output"];
};

export type MarkPrivilegeLevelAsDefaultInput = {
  privilegeLevelId: Scalars["ID"]["input"];
};

export type MarkPrivilegeLevelAsDefaultResponse = {
  __typename: "MarkPrivilegeLevelAsDefaultResponse";
  privilegeLevel: PrivilegeLevel;
};

export type MarkRecordingAsReviewedInput = {
  meetingId: Scalars["ID"]["input"];
};

export type MarkRecordingAsReviewedResponse = {
  __typename: "MarkRecordingAsReviewedResponse";
  success: Scalars["Boolean"]["output"];
};

export type MarkUnreadNotificationsAsReadResponse = {
  __typename: "MarkUnreadNotificationsAsReadResponse";
  currentCorrespondent: Correspondent;
  notificationEvents: Array<NotificationEvent>;
};

export type Meeting = {
  __typename: "Meeting";
  call?: Maybe<Call>;
  confidential: Scalars["Boolean"]["output"];
  connections: Array<Connection>;
  contacts: Array<Correspondent>;
  correspondents: Array<Correspondent>;
  facility: Facility;
  id: Scalars["ID"]["output"];
  inmates: Array<Inmate>;
  interval: Interval;
  isPrivilegeException: Scalars["Boolean"]["output"];
  kiosk?: Maybe<Kiosk>;
  meetingItems: Array<MeetingItem>;
  meetingType: MeetingType;
  notes?: Maybe<Scalars["String"]["output"]>;
  participantComment?: Maybe<ParticipantComment>;
  pendingRequestTask?: Maybe<Task>;
  /**
   * PrimaryVisitor may be null when staff schedule in-person visits without
   * any registered Ameelio Connect visitors.
   */
  primaryVisitor?: Maybe<Visitor>;
  reviewedBy?: Maybe<StaffPosition>;
  schedulerId: Scalars["String"]["output"];
  schedulerType: MeetingSchedulerType;
  security: Array<SecurityFeature>;
  status: MeetingStatus;
  statusDetails?: Maybe<Scalars["String"]["output"]>;
  timelineEvents: Array<StaffTimelineEvent>;
  title?: Maybe<Scalars["String"]["output"]>;
  unregisteredGuests: Array<Scalars["String"]["output"]>;
  visitors: Array<Visitor>;
};

export type MeetingMeetingItemsArgs = {
  includeRejected?: Scalars["Boolean"]["input"];
};

export type MeetingAvailability = {
  __typename: "MeetingAvailability";
  availableKiosks: Array<Kiosk>;
  conflict: Scalars["Boolean"]["output"];
  exceedsLimit: Scalars["Boolean"]["output"];
  interval: Interval;
  privacyLevel: PrivacyLevel;
  timeliness: Timeliness;
  unavailableKiosks: Array<Kiosk>;
};

export type MeetingBadgeCounts = {
  __typename: "MeetingBadgeCounts";
  confidentialInPerson: Scalars["Int"]["output"];
  confidentialVideo: Scalars["Int"]["output"];
  personalInPerson: Scalars["Int"]["output"];
  personalVideo: Scalars["Int"]["output"];
};

export type MeetingConnection = {
  __typename: "MeetingConnection";
  count: Scalars["Int"]["output"];
  countByDay: Array<CountGroup>;
  edges: Array<MeetingEdge>;
  pageInfo: PageInfo;
  ratings: Array<CountGroup>;
  ratingsByType: RatingByType;
  uniqueInmates: Scalars["Int"]["output"];
  uniqueVisitors: Scalars["Int"]["output"];
};

export type MeetingEdge = {
  __typename: "MeetingEdge";
  cursor: Scalars["String"]["output"];
  node: Meeting;
};

export type MeetingItem = {
  __typename: "MeetingItem";
  description?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
  status: MeetingItemStatus;
};

export enum MeetingItemStatus {
  Approved = "APPROVED",
  PendingApproval = "PENDING_APPROVAL",
  Rejected = "REJECTED",
}

export enum MeetingSchedulerType {
  Inmate = "INMATE",
  Staff = "STAFF",
  Visitor = "VISITOR",
}

export enum MeetingStatus {
  Cancelled = "CANCELLED",
  Ended = "ENDED",
  Live = "LIVE",
  NoShow = "NO_SHOW",
  PendingApproval = "PENDING_APPROVAL",
  Rejected = "REJECTED",
  Scheduled = "SCHEDULED",
  Terminated = "TERMINATED",
}

export enum MeetingType {
  InPersonVisit = "IN_PERSON_VISIT",
  VideoCall = "VIDEO_CALL",
  VoiceCall = "VOICE_CALL",
  Webinar = "WEBINAR",
}

export type Message = {
  __typename: "Message";
  availability: MessageAvailability;
  availableAt?: Maybe<Scalars["Date"]["output"]>;
  connection: Connection;
  content: Scalars["String"]["output"];
  createdAt: Scalars["Date"]["output"];
  detectedKeywords: Array<MessageDetectedKeyword>;
  fileUrl?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  internalComments?: Maybe<Scalars["String"]["output"]>;
  isInstantReply: Scalars["Boolean"]["output"];
  isRead: Scalars["Boolean"]["output"];
  reviewedAt?: Maybe<Scalars["Date"]["output"]>;
  reviewedBy?: Maybe<StaffPosition>;
  sender: Correspondent;
  status: MessageStatus;
  statusDetails?: Maybe<Scalars["String"]["output"]>;
  type: MessageType;
  updatedAt: Scalars["Date"]["output"];
};

export enum MessageAvailability {
  Available = "AVAILABLE",
  Pending = "PENDING",
  ProcessingFailed = "PROCESSING_FAILED",
  Rejected = "REJECTED",
}

export type MessageConnection = {
  __typename: "MessageConnection";
  count: Scalars["Int"]["output"];
  edges: Array<MessageEdge>;
  pageInfo: PageInfo;
  unreadMessageCount: Scalars["Int"]["output"];
};

export type MessageDetectedKeyword = {
  __typename: "MessageDetectedKeyword";
  id: Scalars["ID"]["output"];
  keyword: MessageKeyword;
  message: Message;
  spelling: Scalars["String"]["output"];
};

export type MessageDetectedKeywordConnection = {
  __typename: "MessageDetectedKeywordConnection";
  edges: Array<MessageDetectedKeywordEdge>;
  pageInfo: PageInfo;
};

export type MessageDetectedKeywordEdge = {
  __typename: "MessageDetectedKeywordEdge";
  cursor: Scalars["String"]["output"];
  node: MessageDetectedKeyword;
};

export type MessageEdge = {
  __typename: "MessageEdge";
  cursor: Scalars["String"]["output"];
  node: Message;
};

export type MessageKeyword = {
  __typename: "MessageKeyword";
  category: MessageKeywordCategory;
  /** @deprecated Use System.staffTimelineEvents instead */
  createdAt?: Maybe<Scalars["Date"]["output"]>;
  /** @deprecated Use System.staffTimelineEvents instead */
  createdBy?: Maybe<StaffPosition>;
  description: Scalars["String"]["output"];
  facility?: Maybe<Facility>;
  id: Scalars["ID"]["output"];
  isActive: Scalars["Boolean"]["output"];
  /** @deprecated Use System.staffTimelineEvents instead */
  lastUpdatedBy?: Maybe<StaffPosition>;
  name: Scalars["String"]["output"];
  spellings: Array<Scalars["String"]["output"]>;
  /** @deprecated Use System.staffTimelineEvents instead */
  updatedAt?: Maybe<Scalars["Date"]["output"]>;
};

export enum MessageKeywordCategory {
  Contraband = "CONTRABAND",
  Drugs = "DRUGS",
  Escape = "ESCAPE",
  Hate = "HATE",
  Other = "OTHER",
  Violence = "VIOLENCE",
}

export enum MessageStatus {
  Approved = "APPROVED",
  PendingReview = "PENDING_REVIEW",
  ProcessingFailed = "PROCESSING_FAILED",
  Queued = "QUEUED",
  Rejected = "REJECTED",
  SkippedReview = "SKIPPED_REVIEW",
}

export enum MessageType {
  Document = "DOCUMENT",
  Photo = "PHOTO",
  Text = "TEXT",
}

export type MetricByMeetingType = {
  __typename: "MetricByMeetingType";
  count: Scalars["Int"]["output"];
  hours: Scalars["Int"]["output"];
  meetingType: MeetingType;
};

export type Mutation = {
  __typename: "Mutation";
  /** @deprecated Use resolveTask instead */
  acceptMeeting: AcceptMeetingResponse;
  acceptOrganizationInvitation: AcceptOrganizationInvitationResponse;
  activateAmeelioStaff: ActivateAmeelioStaffResponse;
  approveMessage: ApproveMessageResponse;
  approveSystemVisitor: ApproveSystemVisitorResponse;
  archiveConnection: ArchiveConnectionResponse;
  beepTablet: BeepTabletResponse;
  cancelMeeting: CancelMeetingResponse;
  cancelOrTerminateMeetings: CancelOrTerminateMeetingsResponse;
  completeStaffRegistration: StaffOrAmeelioStaff;
  /** @deprecated Use completeStaffRegistration instead. */
  completeSystemStaffRegistration: CompleteSystemStaffRegistrationResponse;
  createCallReport: CreateCallReportResponse;
  createConnectionRestriction: CreateConnectionRestrictionResponse;
  createConnectionRestrictions: CreateConnectionRestrictionsResponse;
  createFacility: CreateFacilityResponse;
  createFacilityApprovedPhone: CreateFacilityApprovedPhoneResponse;
  createGroup: CreateGroupResponse;
  createInstantReplyMessage: CreateInstantReplyMessageResponse;
  createKiosk: CreateKioskResponse;
  createLearnInstance: CreateLearnInstanceResponse;
  createLocalMessageKeyword: CreateLocalMessageKeywordResponse;
  createMessage: CreateMessageResponse;
  createOrganization: CreateOrganizationResponse;
  createOrganizationInvitation: CreateOrganizationInvitationResponse;
  createPendingConnection: CreatePendingConnectionResponse;
  createPendingProfessionalConnection: CreatePendingProfessionalConnectionResponse;
  createPrivilege: CreatePrivilegeResponse;
  createPrivilegeLevel: CreatePrivilegeLevelResponse;
  createPstnConnection: CreatePstnConnectionResponse;
  createRecording: CreateRecordingResponse;
  createSchedule: CreateScheduleResponse;
  createScheduledMeeting: CreateScheduledMeetingResponse;
  createStaff: CreateStaffResponse;
  createSurveyImpression: CreateSurveyImpressionResponse;
  createSurveyResponse: CreateSurveyResponseResponse;
  createSystem: CreateSystemResponse;
  createSystemApp: CreateSystemAppResponse;
  createTestCall: CreateTestCallResponse;
  createTranscript: CreateTranscriptResponse;
  createVisitor: CreateVisitorResponse;
  createVisitorIdentity: CreateVisitorIdentityResponse;
  createVisitorVoiceCall: CreateVisitorVoiceCallResponse;
  createVoiceCall: CreateVoiceCallResponse;
  deactivateAmeelioStaff: DeactivateAmeelioStaffResponse;
  deactivateConnection: DeactivateConnectionResponse;
  deactivateFacility: DeactivateFacilityResponse;
  deactivateLocalMessageKeyword: DeactivateLocalMessageKeywordResponse;
  deactivateOrganization: DeactivateOrganizationResponse;
  deactivateOrganizationMembership: DeactivateOrganizationMembershipResponse;
  deactivateStaff: DeactivateStaffResponse;
  declineVoiceCall: DeclineVoiceCallResponse;
  deleteGroup: DeleteGroupResponse;
  deletePrivilege: DeletePrivilegeResponse;
  deletePrivilegeLevel: DeletePrivilegeLevelResponse;
  deleteSchedule: DeleteScheduleResponse;
  deleteVisitor: DeleteVisitorResponse;
  downloadScreenshots: DownloadScreenshotsResponse;
  downloadTranscript: DownloadTranscriptResponse;
  enableInmatePasswordReset: EnableInmatePasswordResetResponse;
  endVoiceCall: EndVoiceCallResponse;
  extendSession: ExtendSessionResponse;
  leaveMeeting: LeaveMeetingResponse;
  login: LoginResponse;
  logout: LogoutResponse;
  markPrivilegeLevelAsDefault: MarkPrivilegeLevelAsDefaultResponse;
  markUnreadNotificationsAsRead: MarkUnreadNotificationsAsReadResponse;
  reactivateLocalMessageKeyword: ReactivateLocalMessageKeywordResponse;
  rebootTablet: RebootTabletResponse;
  registerDevice: RegisterDeviceResponse;
  rejectMessage: RejectMessageResponse;
  /** @deprecated Use cancelOrTerminateMeetings instead */
  rejectOrTerminateMeetings: RejectOrTerminateMeetingsResponse;
  rejectSystemVisitor: RejectSystemVisitorResponse;
  reportProblemWithRecording: ReportProblemWithArtifactResponse;
  reportProblemWithScreenshots: ReportProblemWithArtifactResponse;
  reprocessRecording: ReprocessRecordingResponse;
  requestDeviceApproval: RequestDeviceApprovalResponse;
  resolveMeetingRequestTask: ResolveTaskResponse;
  resolveTask: ResolveTaskResponse;
  revokeOrganizationInvitation: RevokeOrganizationInvitationResponse;
  setFacilityTabletGroups: SetFacilityTabletGroupsResponse;
  setMeetingNoShow: SetMeetingNoShowResponse;
  setSystemIdp: SetSystemIdpResponse;
  syncDeviceApprovals: SyncDeviceApprovalsResponse;
  terminateCall: TerminateCallResponse;
  unregisterDevice: UnregisterDeviceResponse;
  updateAmeelioStaff: UpdateAmeelioStaffResponse;
  updateCallStatus: UpdateCallStatusResponse;
  updateConnectionRelationship: UpdateConnectionRelationshipResponse;
  updateConnectionRestriction: UpdateConnectionRestrictionResponse;
  updateConnectionStatus: UpdateConnectionStatusResponse;
  updateFacility: UpdateFacilityResponse;
  updateFacilityApprovedPhone: UpdateFacilityApprovedPhoneResponse;
  updateFacilityFeatures: UpdateFacilityFeaturesResponse;
  updateGroup: UpdateGroupResponse;
  updateInmate: UpdateInmateResponse;
  updateInmatePassword: UpdateInmatePasswordResponse;
  updateInmatePrivilegeLevel: UpdateInmatePrivilegeLevelResponse;
  updateKiosk: UpdateKioskResponse;
  updateLanguagePreference: UpdateLanguagePreferenceResponse;
  updateLocalMessageKeyword: UpdateLocalMessageKeywordResponse;
  updateMeetingParticipantComment: UpdateMeetingParticipantCommentResponse;
  updateMessageIsRead: UpdateMessageIsReadResponse;
  updateNotificationEventReadAt: UpdateNotificationEventReadAtResponse;
  updateOrganizationMembership: UpdateOrganizationMembershipResponse;
  updatePrivilege: UpdatePrivilegeResponse;
  updatePrivilegeLevel: UpdatePrivilegeLevelResponse;
  updateSchedule: UpdateScheduleResponse;
  updateScheduledMeeting: UpdateScheduledMeetingResponse;
  updateStaff: UpdateStaffResponse;
  updateStaffPreferences: UpdateStaffPreferencesResponse;
  updateSystem: UpdateSystemResponse;
  updateVisitor: UpdateVisitorResponse;
  updateVisitorEmail: UpdateVisitorEmailResponse;
  updateVisitorIdentity: UpdateVisitorIdentityResponse;
  updateVisitorPstnNumber: UpdateVisitorPstnNumberResponse;
};

export type MutationAcceptMeetingArgs = {
  input: AcceptMeetingInput;
};

export type MutationAcceptOrganizationInvitationArgs = {
  input: AcceptOrganizationInvitationInput;
};

export type MutationActivateAmeelioStaffArgs = {
  input: ActivateAmeelioStaffInput;
};

export type MutationApproveMessageArgs = {
  input: ApproveMessageInput;
};

export type MutationApproveSystemVisitorArgs = {
  input: ApproveSystemVisitorInput;
};

export type MutationArchiveConnectionArgs = {
  input: ArchiveConnectionInput;
};

export type MutationBeepTabletArgs = {
  input: BeepTabletInput;
};

export type MutationCancelMeetingArgs = {
  input: CancelMeetingInput;
};

export type MutationCancelOrTerminateMeetingsArgs = {
  input: CancelOrTerminateMeetingsInput;
};

export type MutationCreateCallReportArgs = {
  input: CreateCallReportInput;
};

export type MutationCreateConnectionRestrictionArgs = {
  input: CreateConnectionRestrictionInput;
};

export type MutationCreateConnectionRestrictionsArgs = {
  input: CreateConnectionRestrictionsInput;
};

export type MutationCreateFacilityArgs = {
  input: CreateFacilityInput;
};

export type MutationCreateFacilityApprovedPhoneArgs = {
  input: CreateFacilityApprovedPhoneInput;
};

export type MutationCreateGroupArgs = {
  input: CreateGroupInput;
};

export type MutationCreateInstantReplyMessageArgs = {
  input: CreateInstantReplyMessageInput;
};

export type MutationCreateKioskArgs = {
  input: CreateKioskInput;
};

export type MutationCreateLearnInstanceArgs = {
  input: CreateLearnInstanceInput;
};

export type MutationCreateLocalMessageKeywordArgs = {
  input: CreateLocalMessageKeywordInput;
};

export type MutationCreateMessageArgs = {
  input: CreateMessageInput;
};

export type MutationCreateOrganizationArgs = {
  input: CreateOrganizationInput;
};

export type MutationCreateOrganizationInvitationArgs = {
  input: CreateOrganizationInvitationInput;
};

export type MutationCreatePendingConnectionArgs = {
  input: CreatePendingConnectionInput;
};

export type MutationCreatePendingProfessionalConnectionArgs = {
  input: CreatePendingProfessionalConnectionInput;
};

export type MutationCreatePrivilegeArgs = {
  input: CreatePrivilegeInput;
};

export type MutationCreatePrivilegeLevelArgs = {
  input: CreatePrivilegeLevelInput;
};

export type MutationCreatePstnConnectionArgs = {
  input: CreatePstnConnectionInput;
};

export type MutationCreateRecordingArgs = {
  input: CreateRecordingInput;
};

export type MutationCreateScheduleArgs = {
  input: CreateScheduleInput;
};

export type MutationCreateScheduledMeetingArgs = {
  input: CreateScheduledMeetingInput;
};

export type MutationCreateStaffArgs = {
  input: CreateStaffInput;
};

export type MutationCreateSurveyImpressionArgs = {
  input: CreateSurveyImpressionInput;
};

export type MutationCreateSurveyResponseArgs = {
  input: CreateSurveyResponseInput;
};

export type MutationCreateSystemArgs = {
  input: CreateSystemInput;
};

export type MutationCreateSystemAppArgs = {
  input: CreateSystemAppInput;
};

export type MutationCreateTranscriptArgs = {
  input: CreateTranscriptInput;
};

export type MutationCreateVisitorArgs = {
  input: CreateVisitorInput;
};

export type MutationCreateVisitorIdentityArgs = {
  input: CreateVisitorIdentityInput;
};

export type MutationCreateVisitorVoiceCallArgs = {
  input: CreateVisitorVoiceCallInput;
};

export type MutationCreateVoiceCallArgs = {
  input: CreateVoiceCallInput;
};

export type MutationDeactivateAmeelioStaffArgs = {
  input: DeactivateAmeelioStaffInput;
};

export type MutationDeactivateConnectionArgs = {
  input: DeactivateConnectionInput;
};

export type MutationDeactivateFacilityArgs = {
  input: DeactivateFacilityInput;
};

export type MutationDeactivateLocalMessageKeywordArgs = {
  input: DeactivateLocalMessageKeywordInput;
};

export type MutationDeactivateOrganizationArgs = {
  input: DeactivateOrganizationInput;
};

export type MutationDeactivateOrganizationMembershipArgs = {
  input: DeactivateOrganizationMembershipInput;
};

export type MutationDeactivateStaffArgs = {
  input: DeactivateStaffInput;
};

export type MutationDeclineVoiceCallArgs = {
  input: DeclineVoiceCallInput;
};

export type MutationDeleteGroupArgs = {
  input: DeleteGroupInput;
};

export type MutationDeletePrivilegeArgs = {
  input: DeletePrivilegeInput;
};

export type MutationDeletePrivilegeLevelArgs = {
  input: DeletePrivilegeLevelInput;
};

export type MutationDeleteScheduleArgs = {
  input: DeleteScheduleInput;
};

export type MutationDeleteVisitorArgs = {
  input: DeleteVisitorInput;
};

export type MutationDownloadScreenshotsArgs = {
  input: DownloadScreenshotsInput;
};

export type MutationDownloadTranscriptArgs = {
  input: DownloadTranscriptInput;
};

export type MutationEnableInmatePasswordResetArgs = {
  input: EnableInmatePasswordResetInput;
};

export type MutationEndVoiceCallArgs = {
  input: EndVoiceCallInput;
};

export type MutationLeaveMeetingArgs = {
  input: LeaveMeetingInput;
};

export type MutationLoginArgs = {
  input: LoginInput;
};

export type MutationLogoutArgs = {
  input: LogoutInput;
};

export type MutationMarkPrivilegeLevelAsDefaultArgs = {
  input: MarkPrivilegeLevelAsDefaultInput;
};

export type MutationReactivateLocalMessageKeywordArgs = {
  input: ReactivateLocalMessageKeywordInput;
};

export type MutationRebootTabletArgs = {
  input: RebootTabletInput;
};

export type MutationRegisterDeviceArgs = {
  input: RegisterDeviceInput;
};

export type MutationRejectMessageArgs = {
  input: RejectMessageInput;
};

export type MutationRejectOrTerminateMeetingsArgs = {
  input: RejectOrTerminateMeetingsInput;
};

export type MutationRejectSystemVisitorArgs = {
  input: RejectSystemVisitorInput;
};

export type MutationReportProblemWithRecordingArgs = {
  input: ReportProblemWithArtifactInput;
};

export type MutationReportProblemWithScreenshotsArgs = {
  input: ReportProblemWithArtifactInput;
};

export type MutationReprocessRecordingArgs = {
  input: ReprocessRecordingInput;
};

export type MutationRequestDeviceApprovalArgs = {
  input: RequestDeviceApprovalInput;
};

export type MutationResolveMeetingRequestTaskArgs = {
  input: ResolveMeetingRequestTaskInput;
};

export type MutationResolveTaskArgs = {
  input: ResolveTaskInput;
};

export type MutationRevokeOrganizationInvitationArgs = {
  input: RevokeOrganizationInvitationInput;
};

export type MutationSetFacilityTabletGroupsArgs = {
  input: SetFacilityTabletGroupsInput;
};

export type MutationSetMeetingNoShowArgs = {
  input: SetMeetingNoShowInput;
};

export type MutationSetSystemIdpArgs = {
  input: SetSystemIdpInput;
};

export type MutationSyncDeviceApprovalsArgs = {
  input: SyncDeviceApprovalsInput;
};

export type MutationTerminateCallArgs = {
  input: TerminateCallInput;
};

export type MutationUnregisterDeviceArgs = {
  input: UnregisterDeviceInput;
};

export type MutationUpdateAmeelioStaffArgs = {
  input: UpdateAmeelioStaffInput;
};

export type MutationUpdateCallStatusArgs = {
  input: UpdateCallStatusInput;
};

export type MutationUpdateConnectionRelationshipArgs = {
  input: UpdateConnectionRelationshipInput;
};

export type MutationUpdateConnectionRestrictionArgs = {
  input: UpdateConnectionRestrictionInput;
};

export type MutationUpdateConnectionStatusArgs = {
  input: UpdateConnectionStatusInput;
};

export type MutationUpdateFacilityArgs = {
  input: UpdateFacilityInput;
};

export type MutationUpdateFacilityApprovedPhoneArgs = {
  input: UpdateFacilityApprovedPhoneInput;
};

export type MutationUpdateFacilityFeaturesArgs = {
  input: UpdateFacilityFeaturesInput;
};

export type MutationUpdateGroupArgs = {
  input: UpdateGroupInput;
};

export type MutationUpdateInmateArgs = {
  input: UpdateInmateInput;
};

export type MutationUpdateInmatePasswordArgs = {
  input: UpdateInmatePasswordInput;
};

export type MutationUpdateInmatePrivilegeLevelArgs = {
  input: UpdateInmatePrivilegeLevelInput;
};

export type MutationUpdateKioskArgs = {
  input: UpdateKioskInput;
};

export type MutationUpdateLanguagePreferenceArgs = {
  input: UpdateLanguagePreferenceInput;
};

export type MutationUpdateLocalMessageKeywordArgs = {
  input: UpdateLocalMessageKeywordInput;
};

export type MutationUpdateMeetingParticipantCommentArgs = {
  input: UpdateMeetingParticipantCommentInput;
};

export type MutationUpdateMessageIsReadArgs = {
  input: UpdateMessageIsReadInput;
};

export type MutationUpdateNotificationEventReadAtArgs = {
  input: UpdateNotificationEventReadAtInput;
};

export type MutationUpdateOrganizationMembershipArgs = {
  input: UpdateOrganizationMembershipInput;
};

export type MutationUpdatePrivilegeArgs = {
  input: UpdatePrivilegeInput;
};

export type MutationUpdatePrivilegeLevelArgs = {
  input: UpdatePrivilegeLevelInput;
};

export type MutationUpdateScheduleArgs = {
  input: UpdateScheduleInput;
};

export type MutationUpdateScheduledMeetingArgs = {
  input: UpdateScheduledMeetingInput;
};

export type MutationUpdateStaffArgs = {
  input: UpdateStaffInput;
};

export type MutationUpdateStaffPreferencesArgs = {
  input: UpdateStaffPreferencesInput;
};

export type MutationUpdateSystemArgs = {
  input: UpdateSystemInput;
};

export type MutationUpdateVisitorArgs = {
  input: UpdateVisitorInput;
};

export type MutationUpdateVisitorEmailArgs = {
  input: UpdateVisitorEmailInput;
};

export type MutationUpdateVisitorIdentityArgs = {
  input: UpdateVisitorIdentityInput;
};

export type MutationUpdateVisitorPstnNumberArgs = {
  input: UpdateVisitorPstnNumberInput;
};

export type NotificationEvent = {
  __typename: "NotificationEvent";
  body: Scalars["String"]["output"];
  createdAt: Scalars["Date"]["output"];
  id: Scalars["ID"]["output"];
  isRead: Scalars["Boolean"]["output"];
  object: NotificationEventObject;
  params: Scalars["String"]["output"];
  sentAt?: Maybe<Scalars["Date"]["output"]>;
  title: Scalars["String"]["output"];
  type: Scalars["String"]["output"];
  verb: NotificationEventVerb;
};

export type NotificationEventConnection = {
  __typename: "NotificationEventConnection";
  edges: Array<NotificationEventEdge>;
  pageInfo: PageInfo;
  unreadNotificationCount: Scalars["Int"]["output"];
};

export type NotificationEventEdge = {
  __typename: "NotificationEventEdge";
  cursor: Scalars["String"]["output"];
  node: NotificationEvent;
};

export type NotificationEventObject =
  Connection | Meeting | Message | Organization | SystemUser;

export enum NotificationEventVerb {
  Approve = "APPROVE",
  Call = "CALL",
  Cancel = "CANCEL",
  Create = "CREATE",
  Reject = "REJECT",
  Remind = "REMIND",
  Update = "UPDATE",
}

export type Organization = {
  __typename: "Organization";
  address: Address;
  allConnections: Array<Connection>;
  connectedFacilities: Array<Facility>;
  description: Scalars["String"]["output"];
  email: Scalars["String"]["output"];
  /** @deprecated No longer supported */
  facilityOrganizations: Array<FacilityOrganization>;
  id: Scalars["ID"]["output"];
  invitations: Array<OrganizationInvitation>;
  logoImageUrl?: Maybe<Scalars["String"]["output"]>;
  memberships: Array<OrganizationMembership>;
  name: Scalars["String"]["output"];
  phone: Scalars["String"]["output"];
  type: OrganizationType;
  websiteLink?: Maybe<Scalars["String"]["output"]>;
};

export type OrganizationFacilityOrganizationsArgs = {
  status?: InputMaybe<FacilityOrganizationStatus>;
};

export type OrganizationMembershipsArgs = {
  role?: InputMaybe<OrganizationMembershipRole>;
};

export type OrganizationConnection = {
  __typename: "OrganizationConnection";
  edges: Array<OrganizationEdge>;
  pageInfo: PageInfo;
};

export type OrganizationEdge = {
  __typename: "OrganizationEdge";
  cursor: Scalars["String"]["output"];
  node: Organization;
};

export type OrganizationInvitation = {
  __typename: "OrganizationInvitation";
  email: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  inviteCode: Scalars["String"]["output"];
  organization: Organization;
  role: OrganizationMembershipRole;
  status: OrganizationInvitationStatus;
};

export enum OrganizationInvitationStatus {
  Accepted = "ACCEPTED",
  Expired = "EXPIRED",
  Pending = "PENDING",
}

export type OrganizationMembership = {
  __typename: "OrganizationMembership";
  createdAt: Scalars["Date"]["output"];
  id: Scalars["ID"]["output"];
  organization: Organization;
  role: OrganizationMembershipRole;
  status: OrganizationMembershipStatus;
  updatedAt: Scalars["Date"]["output"];
  visitor: Visitor;
};

export enum OrganizationMembershipRole {
  Admin = "ADMIN",
  Member = "MEMBER",
}

export enum OrganizationMembershipStatus {
  Active = "ACTIVE",
  Inactive = "INACTIVE",
}

export enum OrganizationType {
  Educational = "EDUCATIONAL",
  Healthcare = "HEALTHCARE",
  Legal = "LEGAL",
  Other = "OTHER",
}

export type PageInfo = {
  __typename: "PageInfo";
  endCursor: Scalars["String"]["output"];
  hasNextPage: Scalars["Boolean"]["output"];
  hasPreviousPage: Scalars["Boolean"]["output"];
  startCursor: Scalars["String"]["output"];
};

export enum ParticipantComment {
  CallBackFiveMinutes = "CALL_BACK_FIVE_MINUTES",
  CallBackNow = "CALL_BACK_NOW",
  CallBackTwoMinutes = "CALL_BACK_TWO_MINUTES",
  CantMakeOnce = "CANT_MAKE_ONCE",
  CantMakeThisTimeAnyDay = "CANT_MAKE_THIS_TIME_ANY_DAY",
  CantMakeThisTimeThisWeekday = "CANT_MAKE_THIS_TIME_THIS_WEEKDAY",
  CantMakeThisTimeWeekdays = "CANT_MAKE_THIS_TIME_WEEKDAYS",
  CantTalkNow = "CANT_TALK_NOW",
}

export enum ParticipantRole {
  Monitor = "MONITOR",
  VisitParticipant = "VISIT_PARTICIPANT",
  WebinarAttendee = "WEBINAR_ATTENDEE",
  WebinarHost = "WEBINAR_HOST",
  WebinarIsolatedAttendee = "WEBINAR_ISOLATED_ATTENDEE",
}

export enum ParticipantType {
  Doc = "DOC",
  Inmate = "INMATE",
  User = "USER",
}

export type PendingConnectionRequestsCounts = {
  __typename: "PendingConnectionRequestsCounts";
  confidential: Scalars["Int"]["output"];
  personal: Scalars["Int"]["output"];
};

export type PendingTasksCounts = {
  __typename: "PendingTasksCounts";
  contactRequests: Scalars["Int"]["output"];
  deviceApprovals: Scalars["Int"]["output"];
  flaggedMessages: Scalars["Int"]["output"];
  inPersonVisitRequests: Scalars["Int"]["output"];
  meetingRequests: Scalars["Int"]["output"];
  total: Scalars["Int"]["output"];
  videoCallRequests: Scalars["Int"]["output"];
};

export type PhoneCall = {
  __typename: "PhoneCall";
  end?: Maybe<Scalars["Date"]["output"]>;
  facilityApprovedPhone: FacilityApprovedPhone;
  id: Scalars["String"]["output"];
  inmate: Inmate;
  security: Array<SecurityFeature>;
  start: Scalars["Date"]["output"];
  status: PhoneCallStatus;
};

export type PhoneCallConnection = {
  __typename: "PhoneCallConnection";
  count: Scalars["Int"]["output"];
  edges: Array<PhoneCallEdge>;
  pageInfo: PageInfo;
};

export type PhoneCallEdge = {
  __typename: "PhoneCallEdge";
  cursor: Scalars["String"]["output"];
  node: PhoneCall;
};

export enum PhoneCallStatus {
  Busy = "BUSY",
  Canceled = "CANCELED",
  Completed = "COMPLETED",
  Failed = "FAILED",
  Initiated = "INITIATED",
  InProgress = "IN_PROGRESS",
  NoAnswer = "NO_ANSWER",
  Ringing = "RINGING",
}

export enum PrivacyLevel {
  Hidden = "HIDDEN",
  Monitored = "MONITORED",
  UnmonitoredLogged = "UNMONITORED_LOGGED",
}

export enum PrivateFileCategory {
  BackId = "BACK_ID",
  FrontId = "FRONT_ID",
  SelfieId = "SELFIE_ID",
}

export type Privilege = {
  __typename: "Privilege";
  amount?: Maybe<Scalars["Int"]["output"]>;
  contactTypes: Array<PrivilegeContactType>;
  id: Scalars["ID"]["output"];
  meetingTypes: Array<MeetingType>;
  period?: Maybe<PrivilegePeriod>;
  unit?: Maybe<PrivilegeUnit>;
  weekBeginsOn?: Maybe<Scalars["Int"]["output"]>;
};

export enum PrivilegeContactType {
  Educational = "EDUCATIONAL",
  Healthcare = "HEALTHCARE",
  Legal = "LEGAL",
  Other = "OTHER",
  Public = "PUBLIC",
}

export type PrivilegeLevel = {
  __typename: "PrivilegeLevel";
  facility: Facility;
  facilityId: Scalars["ID"]["output"];
  id: Scalars["ID"]["output"];
  isDefault: Scalars["Boolean"]["output"];
  name: Scalars["String"]["output"];
  privileges: Array<Privilege>;
};

export enum PrivilegePeriod {
  Daily = "DAILY",
  Monthly = "MONTHLY",
  Weekly = "WEEKLY",
}

export enum PrivilegeUnit {
  Count = "COUNT",
  Minutes = "MINUTES",
}

export type Query = {
  __typename: "Query";
  adultInmates: AdultInmatesResponse;
  ameelioStaffList: Array<AmeelioStaff>;
  appInfo: AppInfoResponse;
  availableTabletGroups: Array<AvailableTabletGroup>;
  call: CallResponse;
  connection: Connection;
  connectionRestriction: ConnectionRestriction;
  currentCorrespondent?: Maybe<Correspondent>;
  /**
   * ISO-3166-1 Alpha 2 code designating a country, or null if no
   * country could be determined.
   */
  currentCountry?: Maybe<Scalars["String"]["output"]>;
  currentInmate?: Maybe<Inmate>;
  currentStaff?: Maybe<Staff>;
  currentStaffOrAmeelioStaff?: Maybe<StaffOrAmeelioStaff>;
  currentVisitor?: Maybe<Visitor>;
  facilities: Array<Facility>;
  facility: Facility;
  facilityApprovedPhone: FacilityApprovedPhone;
  inmate: Inmate;
  inmatePasswordResetEligibility: InmatePasswordResetEligibilityResponse;
  kiosk: Kiosk;
  /** @deprecated Use the login mutation instead */
  loginUser: LoginResponse;
  me?: Maybe<User>;
  meeting: Meeting;
  message: Message;
  minorInmate?: Maybe<InmateSearchResult>;
  organization: Organization;
  organizationInvitation: OrganizationInvitation;
  organizationInvitationByCode?: Maybe<OrganizationInvitation>;
  organizationInvitationByUser?: Maybe<OrganizationInvitation>;
  organizationMembership: OrganizationMembership;
  organizations: OrganizationConnection;
  ping: Scalars["String"]["output"];
  privilege: Privilege;
  privilegeLevel: PrivilegeLevel;
  reports: Reports;
  schedule: Schedule;
  staff: Staff;
  staffPosition: StaffPosition;
  suggestedMeetingGuests: Array<SuggestedGuest>;
  system: System;
  systemByCode?: Maybe<System>;
  systems: Array<System>;
  tabletCommandStatus: TabletCommandStatus;
  task: Task;
  twilioToken: Scalars["String"]["output"];
  uploadUrl: UploadUrl;
  visitor: Visitor;
  visitors: SearchVisitorsResponse;
};

export type QueryAdultInmatesArgs = {
  country?: InputMaybe<Scalars["String"]["input"]>;
  dateOfBirth?: InputMaybe<Scalars["String"]["input"]>;
  facilityId?: InputMaybe<Scalars["String"]["input"]>;
  inmateIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  lastNameOrInmateId?: InputMaybe<Scalars["String"]["input"]>;
  province?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryAvailableTabletGroupsArgs = {
  facilityId: Scalars["ID"]["input"];
  mdm: TabletMdm;
};

export type QueryCallArgs = {
  callId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type QueryConnectionArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryConnectionRestrictionArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryFacilityArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryFacilityApprovedPhoneArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryInmateArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryInmatePasswordResetEligibilityArgs = {
  username: Scalars["String"]["input"];
};

export type QueryKioskArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryLoginUserArgs = {
  input: CredentialsInput;
};

export type QueryMeetingArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryMessageArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryMinorInmateArgs = {
  dateOfBirth: Scalars["String"]["input"];
  facilityId: Scalars["String"]["input"];
  firstName: Scalars["String"]["input"];
  lastName: Scalars["String"]["input"];
};

export type QueryOrganizationArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryOrganizationInvitationArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryOrganizationInvitationByCodeArgs = {
  inviteCode: Scalars["String"]["input"];
};

export type QueryOrganizationMembershipArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryPrivilegeArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryPrivilegeLevelArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryScheduleArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryStaffArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryStaffPositionArgs = {
  id: Scalars["ID"]["input"];
};

export type QuerySuggestedMeetingGuestsArgs = {
  connectionId: Scalars["ID"]["input"];
};

export type QuerySystemArgs = {
  id: Scalars["ID"]["input"];
};

export type QuerySystemByCodeArgs = {
  code: Scalars["String"]["input"];
};

export type QueryTabletCommandStatusArgs = {
  commandId: Scalars["ID"]["input"];
  facilityId: Scalars["ID"]["input"];
  tabletId: Scalars["ID"]["input"];
};

export type QueryTaskArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryUploadUrlArgs = {
  contentType: Scalars["String"]["input"];
};

export type QueryVisitorArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryVisitorsArgs = {
  email?: InputMaybe<Scalars["String"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
};

export type RatingByType = {
  __typename: "RatingByType";
  inmate: Array<CountGroup>;
  user: Array<CountGroup>;
};

export type ReactivateLocalMessageKeywordInput = {
  messageKeywordId: Scalars["ID"]["input"];
};

export type ReactivateLocalMessageKeywordResponse = {
  __typename: "ReactivateLocalMessageKeywordResponse";
  messageKeyword: MessageKeyword;
};

export type RebootTabletInput = {
  facilityId: Scalars["ID"]["input"];
  tabletId: Scalars["ID"]["input"];
};

export type RebootTabletResponse = {
  __typename: "RebootTabletResponse";
  commandId: Scalars["ID"]["output"];
  success: Scalars["Boolean"]["output"];
};

export type Recording = {
  __typename: "Recording";
  requester?: Maybe<Staff>;
  status: RecordingStatus;
  url?: Maybe<Scalars["String"]["output"]>;
};

export enum RecordingStatus {
  Available = "AVAILABLE",
  Expired = "EXPIRED",
  NotStarted = "NOT_STARTED",
  Pending = "PENDING",
}

export type RegisterDeviceInput = {
  appVersion?: InputMaybe<Scalars["String"]["input"]>;
  deviceId?: InputMaybe<Scalars["String"]["input"]>;
  token: Scalars["String"]["input"];
  tokenType?: InputMaybe<TokenType>;
  type: DeviceType;
};

export type RegisterDeviceResponse = {
  __typename: "RegisterDeviceResponse";
  id: Scalars["String"]["output"];
  token: Scalars["String"]["output"];
  tokenType: TokenType;
  type: DeviceType;
};

export type RejectMessageInput = {
  internalComments: Scalars["String"]["input"];
  messageId: Scalars["ID"]["input"];
  statusDetails: Scalars["String"]["input"];
};

export type RejectMessageResponse = {
  __typename: "RejectMessageResponse";
  message: Message;
};

export type RejectOrTerminateMeetingsInput = {
  meetingIds: Array<Scalars["ID"]["input"]>;
  reason: Scalars["String"]["input"];
};

export type RejectOrTerminateMeetingsResponse = {
  __typename: "RejectOrTerminateMeetingsResponse";
  failures: Array<Scalars["ID"]["output"]>;
  success: Scalars["Boolean"]["output"];
  successCount: Scalars["Int"]["output"];
};

export type RejectSystemVisitorInput = {
  statusDetails: Scalars["String"]["input"];
  systemVisitorId: Scalars["String"]["input"];
};

export type RejectSystemVisitorResponse = {
  __typename: "RejectSystemVisitorResponse";
  systemVisitor: SystemUser;
};

export type ReportProblemWithArtifactInput = {
  description: Scalars["String"]["input"];
  meetingId: Scalars["ID"]["input"];
  tag: Scalars["String"]["input"];
};

export type ReportProblemWithArtifactResponse = {
  __typename: "ReportProblemWithArtifactResponse";
  success: Scalars["Boolean"]["output"];
};

export type Reports = {
  __typename: "Reports";
  activeInmates: Scalars["Int"]["output"];
  activeInmatesByMeetingType: Array<MetricByMeetingType>;
  activeProfessionalVisitors: Scalars["Int"]["output"];
  activeProfessionalVisitorsByMeetingType: Array<MetricByMeetingType>;
  activeStandardVisitors: Scalars["Int"]["output"];
  activeStandardVisitorsByMeetingType: Array<MetricByMeetingType>;
  callRatings: Array<CallRatingsReportType>;
  systemSatisfaction: Array<SystemSatisfactionType>;
  totalInmates: Scalars["Int"]["output"];
  totalVisitors: Scalars["Int"]["output"];
};

export type ReportsActiveInmatesArgs = {
  endDate: Scalars["String"]["input"];
  startDate: Scalars["String"]["input"];
};

export type ReportsActiveInmatesByMeetingTypeArgs = {
  endDate: Scalars["String"]["input"];
  startDate: Scalars["String"]["input"];
};

export type ReportsActiveProfessionalVisitorsArgs = {
  endDate: Scalars["String"]["input"];
  startDate: Scalars["String"]["input"];
};

export type ReportsActiveProfessionalVisitorsByMeetingTypeArgs = {
  endDate: Scalars["String"]["input"];
  startDate: Scalars["String"]["input"];
};

export type ReportsActiveStandardVisitorsArgs = {
  endDate: Scalars["String"]["input"];
  startDate: Scalars["String"]["input"];
};

export type ReportsActiveStandardVisitorsByMeetingTypeArgs = {
  endDate: Scalars["String"]["input"];
  startDate: Scalars["String"]["input"];
};

export type ReportsCallRatingsArgs = {
  endDate: Scalars["String"]["input"];
  startDate: Scalars["String"]["input"];
};

export type ReprocessRecordingInput = {
  callId: Scalars["ID"]["input"];
};

export type ReprocessRecordingResponse = {
  __typename: "ReprocessRecordingResponse";
  success: Scalars["Boolean"]["output"];
};

export type RequestDeviceApprovalInput = {
  deviceId: Scalars["String"]["input"];
  facilityId: Scalars["ID"]["input"];
};

export type RequestDeviceApprovalResponse = {
  __typename: "RequestDeviceApprovalResponse";
  systemDevice: SystemDevice;
};

export type ResolveMeetingRequestTaskInput = {
  acceptedMeetingItemNames?: InputMaybe<Array<Scalars["String"]["input"]>>;
  reason?: InputMaybe<Scalars["String"]["input"]>;
  resolution: TaskResolution;
  taskId: Scalars["ID"]["input"];
};

export type ResolveTaskInput = {
  reason?: InputMaybe<Scalars["String"]["input"]>;
  resolution: TaskResolution;
  taskId: Scalars["ID"]["input"];
};

export type ResolveTaskResponse = {
  __typename: "ResolveTaskResponse";
  task: Task;
};

export type RevokeOrganizationInvitationInput = {
  organizationInvitationId: Scalars["ID"]["input"];
};

export type RevokeOrganizationInvitationResponse = {
  __typename: "RevokeOrganizationInvitationResponse";
  organizationInvitation: OrganizationInvitation;
};

export type Schedule = {
  __typename: "Schedule";
  capacity: Scalars["Int"]["output"];
  contactTypes: Array<ContactType>;
  endsOn?: Maybe<Scalars["String"]["output"]>;
  facility: Facility;
  groups: Array<Group>;
  id: Scalars["ID"]["output"];
  kiosks: Array<Kiosk>;
  meetingSlots: Array<ScheduleMeetingSlot>;
  meetingTypes: Array<MeetingType>;
  name: Scalars["String"]["output"];
  privacyLevels: Array<PrivacyLevel>;
  privilegeLevels: Array<PrivilegeLevel>;
  startsOn?: Maybe<Scalars["String"]["output"]>;
  /** @deprecated No longer supported */
  visitorTypes: Array<VisitorType>;
};

export type ScheduleMeetingSlot = {
  __typename: "ScheduleMeetingSlot";
  day: Scalars["Int"]["output"];
  duration: Scalars["Int"]["output"];
  hour: Scalars["Int"]["output"];
  id: Scalars["ID"]["output"];
  minute: Scalars["Int"]["output"];
};

export type Screenshot = {
  __typename: "Screenshot";
  createdAt: Scalars["Date"]["output"];
  url: Scalars["String"]["output"];
  user: VisitorOrInmate;
  viewedAt?: Maybe<Scalars["Date"]["output"]>;
  viewedBy?: Maybe<Scalars["String"]["output"]>;
};

export type SearchVisitorsResponse = {
  __typename: "SearchVisitorsResponse";
  results: Array<Visitor>;
};

export enum SecurityFeature {
  Logged = "LOGGED",
  Monitoring = "MONITORING",
  Pictures = "PICTURES",
  Recording = "RECORDING",
}

export type SetFacilityTabletGroupsInput = {
  facilityId: Scalars["ID"]["input"];
  groups: Array<TabletGroupInput>;
  mdm: TabletMdm;
};

export type SetFacilityTabletGroupsResponse = {
  __typename: "SetFacilityTabletGroupsResponse";
  facility: Facility;
};

export type SetMeetingItemInput = {
  description?: InputMaybe<Scalars["String"]["input"]>;
  name: Scalars["String"]["input"];
};

export type SetMeetingNoShowInput = {
  meetingId: Scalars["ID"]["input"];
  reason?: InputMaybe<Scalars["String"]["input"]>;
};

export type SetMeetingNoShowResponse = {
  __typename: "SetMeetingNoShowResponse";
  meeting: Meeting;
};

export type SetSystemIdpInput = {
  idp?: InputMaybe<Scalars["String"]["input"]>;
  systemId: Scalars["ID"]["input"];
};

export type SetSystemIdpResponse = {
  __typename: "SetSystemIdpResponse";
  system: System;
};

export type SetVisitorIdentityInput = {
  idBackImageKey: Scalars["String"]["input"];
  idFrontImageKey: Scalars["String"]["input"];
  selfieImageKey: Scalars["String"]["input"];
};

export type SetVisitorIdentityResponse = {
  __typename: "SetVisitorIdentityResponse";
  identity: VisitorIdentity;
  visitor: Visitor;
};

export type Slot = {
  day: Scalars["Int"]["input"];
  duration: Scalars["Int"]["input"];
  hour: Scalars["Int"]["input"];
  minute: Scalars["Int"]["input"];
};

export type Staff = {
  __typename: "Staff";
  /** @deprecated Moving to AmeelioStaff type */
  ameelio: Scalars["Boolean"]["output"];
  email: Scalars["String"]["output"];
  firstName: Scalars["String"]["output"];
  fullName: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  initials: Scalars["String"]["output"];
  languagePreference?: Maybe<Language>;
  lastName: Scalars["String"]["output"];
  /** @deprecated No longer supported */
  malanId?: Maybe<Scalars["ID"]["output"]>;
  phone?: Maybe<Scalars["String"]["output"]>;
  receiveDailyScheduleEmails: Scalars["Boolean"]["output"];
  receiveFlaggedMessageEmails: Scalars["Boolean"]["output"];
  receiveTaskReminderEmails: Scalars["Boolean"]["output"];
  staffEntitlements: Array<StaffEntitlement>;
  staffPositions: Array<StaffPosition>;
  surveyActivity: Array<Maybe<SurveyActivity>>;
  system: System;
  timelineEvents: StaffTimelineEventConnection;
};

export type StaffStaffPositionsArgs = {
  systemId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type StaffTimelineEventsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  createdAfter?: InputMaybe<Scalars["Date"]["input"]>;
  createdBefore?: InputMaybe<Scalars["Date"]["input"]>;
  facilityId?: InputMaybe<Scalars["ID"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type StaffEntitlement = {
  __typename: "StaffEntitlement";
  entitlement: Entitlement;
  id: Scalars["ID"]["output"];
  isActive: Scalars["Boolean"]["output"];
  staff: Staff;
};

export type StaffOrAmeelioStaff = AmeelioStaff | Staff;

export type StaffPosition = {
  __typename: "StaffPosition";
  facility: Facility;
  id: Scalars["ID"]["output"];
  isActive: Scalars["Boolean"]["output"];
  reviewedConnections: Array<Connection>;
  reviewedMeetings: Array<Meeting>;
  staff: Staff;
  /** @deprecated No longer supported */
  timelineEvents: StaffTimelineEventConnection;
};

export type StaffPositionTimelineEventsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  createdAfter?: InputMaybe<Scalars["Date"]["input"]>;
  createdBefore?: InputMaybe<Scalars["Date"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type StaffTimelineEvent = {
  __typename: "StaffTimelineEvent";
  createdAt: Scalars["Date"]["output"];
  facility?: Maybe<Facility>;
  id: Scalars["ID"]["output"];
  metadata?: Maybe<Scalars["String"]["output"]>;
  object: StaffTimelineEventObject;
  /** @deprecated Use `subject` instead */
  staff: Staff;
  subject: StaffOrAmeelioStaff;
  verb: TimelineEventVerb;
};

export type StaffTimelineEventConnection = {
  __typename: "StaffTimelineEventConnection";
  count: Scalars["Int"]["output"];
  edges: Array<StaffTimelineEventEdge>;
  pageInfo: PageInfo;
};

export type StaffTimelineEventEdge = {
  __typename: "StaffTimelineEventEdge";
  cursor: Scalars["String"]["output"];
  node: StaffTimelineEvent;
};

export type StaffTimelineEventObject =
  | Call
  | Connection
  | ConnectionRestriction
  | Facility
  | FacilityApprovedPhone
  | Inmate
  | Kiosk
  | Meeting
  | Message
  | MessageKeyword
  | Privilege
  | PrivilegeLevel
  | Schedule
  | StaffEntitlement
  | StaffPosition
  | System
  | SystemDevice
  | SystemUser;

/** Exactly one of registeredGuest or unregisteredGuestName is set. */
export type SuggestedGuest = {
  __typename: "SuggestedGuest";
  registeredGuest?: Maybe<InmateGuest>;
  unregisteredGuestName?: Maybe<Scalars["String"]["output"]>;
};

export type SurveyActivity = {
  __typename: "SurveyActivity";
  code: Scalars["String"]["output"];
  impressions: Scalars["Int"]["output"];
  responses: Scalars["Int"]["output"];
};

export type SurveyAnswer = {
  answer: Scalars["String"]["input"];
  code: Scalars["String"]["input"];
  page?: InputMaybe<Scalars["Int"]["input"]>;
  version: Scalars["Int"]["input"];
};

export type SyncDeviceApprovalsInput = {
  deviceId: Scalars["String"]["input"];
};

export type SyncDeviceApprovalsResponse = {
  __typename: "SyncDeviceApprovalsResponse";
  systemDevices: Array<SystemDevice>;
};

export type System = {
  __typename: "System";
  allowInmatePasswordReset: Scalars["Boolean"]["output"];
  code: Scalars["String"]["output"];
  dataRetention?: Maybe<Scalars["Int"]["output"]>;
  /** @deprecated This field is no longer used and will be removed in a future version of the API. */
  enableCovertMessageFlagging: Scalars["Boolean"]["output"];
  facilities: Array<Facility>;
  hasCallTranscripts: Scalars["Boolean"]["output"];
  hasLearnInstance: Scalars["Boolean"]["output"];
  hasTablets: Scalars["Boolean"]["output"];
  id: Scalars["String"]["output"];
  inmates: InmateConnection;
  maxPasswordAgeDays?: Maybe<Scalars["Int"]["output"]>;
  name: Scalars["String"]["output"];
  recordingRetention: Scalars["Int"]["output"];
  rosterUpdatedAt?: Maybe<Scalars["Date"]["output"]>;
  showPPTOS: Scalars["Boolean"]["output"];
  staff: Array<Staff>;
  timelineEvents: StaffTimelineEventConnection;
  visitorReapprovalDays: Scalars["Int"]["output"];
};

export type SystemInmatesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  facilityId?: InputMaybe<Scalars["ID"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  nameOrIdentification?: InputMaybe<Scalars["String"]["input"]>;
};

export type SystemTimelineEventsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  category?: InputMaybe<TimelineEventCategory>;
  createdAfter?: InputMaybe<Scalars["Date"]["input"]>;
  createdBefore?: InputMaybe<Scalars["Date"]["input"]>;
  facilityId?: InputMaybe<Scalars["ID"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  inmateId?: InputMaybe<Scalars["ID"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  staffId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type SystemApp = {
  __typename: "SystemApp";
  clientId: Scalars["String"]["output"];
  description: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  isActive: Scalars["Boolean"]["output"];
  lastUsedAt?: Maybe<Scalars["Date"]["output"]>;
  origin: Array<Scalars["String"]["output"]>;
  system: System;
};

export type SystemDevice = {
  __typename: "SystemDevice";
  device: Device;
  id: Scalars["ID"]["output"];
  pendingApprovalTask?: Maybe<Task>;
  status: SystemDeviceStatus;
  system: System;
};

export enum SystemDeviceStatus {
  Approved = "APPROVED",
  PendingApproval = "PENDING_APPROVAL",
  Rejected = "REJECTED",
}

export type SystemSatisfactionType = {
  __typename: "SystemSatisfactionType";
  badRatings: Scalars["Int"]["output"];
  name: Scalars["String"]["output"];
  ratings: Scalars["Int"]["output"];
  userType: Scalars["String"]["output"];
  yearWeek: Scalars["String"]["output"];
};

export type SystemUser = {
  __typename: "SystemUser";
  connectedFacilities: Array<Facility>;
  id: Scalars["ID"]["output"];
  status: SystemUserStatus;
  statusDetails?: Maybe<Scalars["String"]["output"]>;
  system: System;
  user: Visitor;
};

export type SystemUserConnectedFacilitiesArgs = {
  connectionStatuses?: InputMaybe<Array<ConnectionStatus>>;
};

export enum SystemUserStatus {
  Approved = "APPROVED",
  Inactive = "INACTIVE",
  Pending = "PENDING",
  Rejected = "REJECTED",
}

export type Tablet = {
  __typename: "Tablet";
  alias?: Maybe<Scalars["String"]["output"]>;
  groupName?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  isActive: Scalars["Boolean"]["output"];
  name: Scalars["String"]["output"];
  serialNumber?: Maybe<Scalars["String"]["output"]>;
  state: TabletState;
};

export enum TabletCommandState {
  Cancelled = "CANCELLED",
  Failure = "FAILURE",
  InProgress = "IN_PROGRESS",
  Queued = "QUEUED",
  Scheduled = "SCHEDULED",
  Success = "SUCCESS",
  TimedOut = "TIMED_OUT",
}

export type TabletCommandStatus = {
  __typename: "TabletCommandStatus";
  commandId: Scalars["ID"]["output"];
  reason?: Maybe<Scalars["String"]["output"]>;
  state: TabletCommandState;
  updatedAt: Scalars["Date"]["output"];
};

export type TabletGroup = {
  __typename: "TabletGroup";
  externalId: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  mdm: TabletMdm;
  name: Scalars["String"]["output"];
};

export type TabletGroupInput = {
  externalId: Scalars["String"]["input"];
};

export enum TabletMdm {
  Esper = "ESPER",
}

export type TabletPage = {
  __typename: "TabletPage";
  items: Array<Tablet>;
  totalCount: Scalars["Int"]["output"];
};

export enum TabletState {
  Disabled = "DISABLED",
  Offline = "OFFLINE",
  Online = "ONLINE",
  Other = "OTHER",
}

export type Task = {
  __typename: "Task";
  connection?: Maybe<Connection>;
  createdAt: Scalars["Date"]["output"];
  facility: Facility;
  id: Scalars["ID"]["output"];
  meeting?: Maybe<Meeting>;
  message?: Maybe<Message>;
  privilegeLevel?: Maybe<PrivilegeLevel>;
  resolved: Scalars["Boolean"]["output"];
  systemDevice?: Maybe<SystemDevice>;
  type: TaskType;
  updatedAt: Scalars["Date"]["output"];
};

export enum TaskResolution {
  Approved = "APPROVED",
  Dismissed = "DISMISSED",
  Rejected = "REJECTED",
}

export enum TaskType {
  ContactRequested = "CONTACT_REQUESTED",
  DeviceApproval = "DEVICE_APPROVAL",
  MeetingRequested = "MEETING_REQUESTED",
  MessageFlagged = "MESSAGE_FLAGGED",
  PrivilegeLevelCreated = "PRIVILEGE_LEVEL_CREATED",
}

export type TerminateCallInput = {
  callId?: InputMaybe<Scalars["ID"]["input"]>;
  meetingId?: InputMaybe<Scalars["ID"]["input"]>;
  reason?: InputMaybe<Scalars["String"]["input"]>;
};

export type TerminateCallResponse = {
  __typename: "TerminateCallResponse";
  success: Scalars["Boolean"]["output"];
};

export enum TimelineEventCategory {
  Contacts = "CONTACTS",
  FacilitySettings = "FACILITY_SETTINGS",
  Meetings = "MEETINGS",
  Messages = "MESSAGES",
  Residents = "RESIDENTS",
  SystemSettings = "SYSTEM_SETTINGS",
  Visitors = "VISITORS",
}

export enum TimelineEventVerb {
  Approve = "APPROVE",
  Cancel = "CANCEL",
  Create = "CREATE",
  Disable = "DISABLE",
  Enable = "ENABLE",
  Monitor = "MONITOR",
  Read = "READ",
  Reject = "REJECT",
  Update = "UPDATE",
}

export enum Timeliness {
  JustRight = "JUST_RIGHT",
  NotAllowed = "NOT_ALLOWED",
  TooLate = "TOO_LATE",
  TooSoon = "TOO_SOON",
}

export enum TokenType {
  Apnvoip = "APNVOIP",
  Fcm = "FCM",
}

export type Transcript = {
  __typename: "Transcript";
  content?: Maybe<Scalars["String"]["output"]>;
  meeting: Meeting;
  status: TranscriptStatus;
};

export type TranscriptSearchResult = {
  __typename: "TranscriptSearchResult";
  content?: Maybe<Scalars["String"]["output"]>;
  contentWithQueryMatch?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  meeting: Meeting;
};

export enum TranscriptStatus {
  Available = "AVAILABLE",
  Expired = "EXPIRED",
  NoTranscript = "NO_TRANSCRIPT",
  Pending = "PENDING",
}

export enum UsState {
  Ak = "AK",
  Al = "AL",
  Ar = "AR",
  Az = "AZ",
  Ca = "CA",
  Co = "CO",
  Ct = "CT",
  Dc = "DC",
  De = "DE",
  Fl = "FL",
  Ga = "GA",
  Hi = "HI",
  Ia = "IA",
  Id = "ID",
  Il = "IL",
  In = "IN",
  Ks = "KS",
  Ky = "KY",
  La = "LA",
  Ma = "MA",
  Md = "MD",
  Me = "ME",
  Mi = "MI",
  Mn = "MN",
  Mo = "MO",
  Ms = "MS",
  Mt = "MT",
  Nc = "NC",
  Nd = "ND",
  Ne = "NE",
  Nh = "NH",
  Nj = "NJ",
  Nm = "NM",
  Nv = "NV",
  Ny = "NY",
  Oh = "OH",
  Ok = "OK",
  Or = "OR",
  Pa = "PA",
  Ri = "RI",
  Sc = "SC",
  Sd = "SD",
  Tn = "TN",
  Tx = "TX",
  Ut = "UT",
  Va = "VA",
  Vt = "VT",
  Wa = "WA",
  Wi = "WI",
  Wv = "WV",
  Wy = "WY",
}

export type UnregisterDeviceInput = {
  token: Scalars["String"]["input"];
};

export type UnregisterDeviceResponse = {
  __typename: "UnregisterDeviceResponse";
  active: Scalars["Boolean"]["output"];
  id: Scalars["String"]["output"];
  token: Scalars["String"]["output"];
};

export type UpdateAmeelioStaffInput = {
  email?: InputMaybe<Scalars["String"]["input"]>;
  entitlements?: InputMaybe<Array<AmeelioStaffEntitlement>>;
  firstName?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["String"]["input"];
  lastName?: InputMaybe<Scalars["String"]["input"]>;
  learnRoles?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type UpdateAmeelioStaffResponse = {
  __typename: "UpdateAmeelioStaffResponse";
  identity: AmeelioStaff;
};

export type UpdateCallStatusInput = {
  unavailableUntil?: InputMaybe<Scalars["Date"]["input"]>;
};

export type UpdateCallStatusResponse = {
  __typename: "UpdateCallStatusResponse";
  visitor: Visitor;
};

export type UpdateConnectionInput = {
  connectionId: Scalars["ID"]["input"];
  status: ConnectionStatus;
  statusDetails?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpdateConnectionRelationshipInput = {
  connectionId: Scalars["ID"]["input"];
  relationship: Scalars["String"]["input"];
};

export type UpdateConnectionRelationshipResponse = {
  __typename: "UpdateConnectionRelationshipResponse";
  connection: Connection;
};

export type UpdateConnectionResponse = {
  __typename: "UpdateConnectionResponse";
  connection: Connection;
};

export type UpdateConnectionRestrictionInput = {
  connectionRestrictionId: Scalars["ID"]["input"];
  expiresAt?: InputMaybe<Scalars["Date"]["input"]>;
  reason?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpdateConnectionRestrictionResponse = {
  __typename: "UpdateConnectionRestrictionResponse";
  connectionRestriction: ConnectionRestriction;
};

export type UpdateConnectionStatusInput = {
  connectionId: Scalars["ID"]["input"];
  status: ConnectionStatus;
  statusDetails?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpdateConnectionStatusResponse = {
  __typename: "UpdateConnectionStatusResponse";
  connection: Connection;
};

export type UpdateFacilityApprovedPhoneInput = {
  active?: InputMaybe<Scalars["Boolean"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  facilityApprovedPhoneId: Scalars["ID"]["input"];
  name?: InputMaybe<Scalars["String"]["input"]>;
  privacyLevel?: InputMaybe<PrivacyLevel>;
};

export type UpdateFacilityApprovedPhoneResponse = {
  __typename: "UpdateFacilityApprovedPhoneResponse";
  facilityApprovedPhone: FacilityApprovedPhone;
};

export type UpdateFacilityFeaturesInput = {
  facilityId: Scalars["ID"]["input"];
  hasConfidentialInPersonVisits?: InputMaybe<Scalars["Boolean"]["input"]>;
  hasConfidentialScreenshots?: InputMaybe<Scalars["Boolean"]["input"]>;
  hasConfidentialVideoCalls?: InputMaybe<Scalars["Boolean"]["input"]>;
  hasInPersonVisits?: InputMaybe<Scalars["Boolean"]["input"]>;
  hasMessaging?: InputMaybe<Scalars["Boolean"]["input"]>;
  hasPhoneCalls?: InputMaybe<Scalars["Boolean"]["input"]>;
  hasPrivilegeLevels?: InputMaybe<Scalars["Boolean"]["input"]>;
  hasPstnCalls?: InputMaybe<Scalars["Boolean"]["input"]>;
  hasSystemDeviceApproval?: InputMaybe<Scalars["Boolean"]["input"]>;
  hasVideoCalls?: InputMaybe<Scalars["Boolean"]["input"]>;
  hasVoiceCalls?: InputMaybe<Scalars["Boolean"]["input"]>;
  hasWebinars?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type UpdateFacilityFeaturesResponse = {
  __typename: "UpdateFacilityFeaturesResponse";
  facility: Facility;
};

export type UpdateFacilityInput = {
  defaultCallQuota?: InputMaybe<Scalars["Int"]["input"]>;
  defaultEmessageDelay?: InputMaybe<Scalars["Int"]["input"]>;
  defaultNeedsMonitor?: InputMaybe<Scalars["Boolean"]["input"]>;
  defaultVisitQuota?: InputMaybe<Scalars["Int"]["input"]>;
  defaultVoiceCallTimeQuota?: InputMaybe<Scalars["Int"]["input"]>;
  email?: InputMaybe<Scalars["String"]["input"]>;
  facilityId: Scalars["ID"]["input"];
  maxVoiceCallDuration?: InputMaybe<Scalars["Int"]["input"]>;
  minimumAgeIdRequired?: InputMaybe<Scalars["Int"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  personalVideoCutoff?: InputMaybe<Scalars["Int"]["input"]>;
  personalVideoWindow?: InputMaybe<Scalars["Int"]["input"]>;
  personalVisitCutoff?: InputMaybe<Scalars["Int"]["input"]>;
  personalVisitWindow?: InputMaybe<Scalars["Int"]["input"]>;
  phone?: InputMaybe<Scalars["String"]["input"]>;
  policyLink?: InputMaybe<Scalars["String"]["input"]>;
  providerVideoCutoff?: InputMaybe<Scalars["Int"]["input"]>;
  providerVideoWindow?: InputMaybe<Scalars["Int"]["input"]>;
  providerVisitCutoff?: InputMaybe<Scalars["Int"]["input"]>;
  providerVisitWindow?: InputMaybe<Scalars["Int"]["input"]>;
  publicId?: InputMaybe<Scalars["String"]["input"]>;
  videoNeedsApproval?: InputMaybe<Scalars["Boolean"]["input"]>;
  videoQuotaResetDay?: InputMaybe<Scalars["Int"]["input"]>;
  virtualBackgrounds?: InputMaybe<VirtualBackground>;
  visitNeedsApproval?: InputMaybe<Scalars["Boolean"]["input"]>;
  visitQuotaResetDay?: InputMaybe<Scalars["Int"]["input"]>;
  visitationFormLink?: InputMaybe<Scalars["String"]["input"]>;
  voiceCallResetTime?: InputMaybe<Scalars["Int"]["input"]>;
};

export type UpdateFacilityResponse = {
  __typename: "UpdateFacilityResponse";
  facility: Facility;
};

export type UpdateGroupInput = {
  description?: InputMaybe<Scalars["String"]["input"]>;
  groupId: Scalars["ID"]["input"];
  name?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpdateGroupResponse = {
  __typename: "UpdateGroupResponse";
  group: Group;
};

export type UpdateInmateInput = {
  hasFilledIntakeForm?: InputMaybe<Scalars["Boolean"]["input"]>;
  inmateId: Scalars["ID"]["input"];
};

export type UpdateInmatePasswordInput = {
  expireExistingSessions?: InputMaybe<Scalars["Boolean"]["input"]>;
  password: Scalars["String"]["input"];
  passwordConfirmation: Scalars["String"]["input"];
  username: Scalars["String"]["input"];
};

export type UpdateInmatePasswordResponse = {
  __typename: "UpdateInmatePasswordResponse";
  success: Scalars["Boolean"]["output"];
};

export type UpdateInmatePrivilegeLevelInput = {
  inmateId: Scalars["ID"]["input"];
  lockedPrivilegeLevel?: InputMaybe<Scalars["Boolean"]["input"]>;
  privilegeLevelId: Scalars["ID"]["input"];
};

export type UpdateInmatePrivilegeLevelResponse = {
  __typename: "UpdateInmatePrivilegeLevelResponse";
  inmate: Inmate;
};

export type UpdateInmateResponse = {
  __typename: "UpdateInmateResponse";
  inmate: Inmate;
};

export type UpdateKioskInput = {
  capacity?: InputMaybe<Scalars["Int"]["input"]>;
  enabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  kioskId: Scalars["ID"]["input"];
  name?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpdateKioskResponse = {
  __typename: "UpdateKioskResponse";
  kiosk: Kiosk;
};

export type UpdateLanguagePreferenceInput = {
  language: Language;
};

export type UpdateLanguagePreferenceResponse = {
  __typename: "UpdateLanguagePreferenceResponse";
  user: VisitorOrInmateOrStaff;
};

export type UpdateLocalMessageKeywordInput = {
  category?: InputMaybe<MessageKeywordCategory>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  messageKeywordId: Scalars["ID"]["input"];
  spellings?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type UpdateLocalMessageKeywordResponse = {
  __typename: "UpdateLocalMessageKeywordResponse";
  messageKeyword: MessageKeyword;
};

export type UpdateMeetingParticipantCommentInput = {
  meetingId: Scalars["ID"]["input"];
  participantComment?: InputMaybe<ParticipantComment>;
};

export type UpdateMeetingParticipantCommentResponse = {
  __typename: "UpdateMeetingParticipantCommentResponse";
  meeting: Meeting;
};

export type UpdateMessageIsReadInput = {
  messageId: Scalars["ID"]["input"];
};

export type UpdateMessageIsReadResponse = {
  __typename: "UpdateMessageIsReadResponse";
  message: Message;
};

export type UpdateNotificationEventReadAtInput = {
  notificationEventId: Scalars["ID"]["input"];
};

export type UpdateNotificationEventReadAtResponse = {
  __typename: "UpdateNotificationEventReadAtResponse";
  notificationEvent: NotificationEvent;
};

export type UpdateOrganizationMembershipInput = {
  organizationMembershipId: Scalars["ID"]["input"];
  role: OrganizationMembershipRole;
};

export type UpdateOrganizationMembershipResponse = {
  __typename: "UpdateOrganizationMembershipResponse";
  organizationMembership: OrganizationMembership;
};

export type UpdatePrivilegeInput = {
  amount?: InputMaybe<Scalars["Int"]["input"]>;
  contactTypes?: InputMaybe<Array<PrivilegeContactType>>;
  meetingTypes?: InputMaybe<Array<MeetingType>>;
  period?: InputMaybe<PrivilegePeriod>;
  privilegeId: Scalars["ID"]["input"];
  unit?: InputMaybe<PrivilegeUnit>;
  weekBeginsOn?: InputMaybe<Scalars["Int"]["input"]>;
};

export type UpdatePrivilegeLevelInput = {
  name?: InputMaybe<Scalars["String"]["input"]>;
  privilegeLevelId: Scalars["ID"]["input"];
};

export type UpdatePrivilegeLevelResponse = {
  __typename: "UpdatePrivilegeLevelResponse";
  privilegeLevel: PrivilegeLevel;
};

export type UpdatePrivilegeResponse = {
  __typename: "UpdatePrivilegeResponse";
  privilege: Privilege;
};

export type UpdateScheduleInput = {
  capacity?: InputMaybe<Scalars["Int"]["input"]>;
  contactTypes?: InputMaybe<Array<ContactType>>;
  endsOn?: InputMaybe<Scalars["String"]["input"]>;
  groupIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  kioskIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  meetingSlots?: InputMaybe<Array<Slot>>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  privacyLevels?: InputMaybe<Array<PrivacyLevel>>;
  privilegeLevelIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  scheduleId: Scalars["ID"]["input"];
  startsOn?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpdateScheduleResponse = {
  __typename: "UpdateScheduleResponse";
  schedule: Schedule;
};

export type UpdateScheduledMeetingInput = {
  connectionIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  inmateIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  isPrivilegeException?: InputMaybe<Scalars["Boolean"]["input"]>;
  kioskId?: InputMaybe<Scalars["ID"]["input"]>;
  meetingId: Scalars["ID"]["input"];
  meetingItems?: InputMaybe<Array<SetMeetingItemInput>>;
  scheduledEnd?: InputMaybe<Scalars["Date"]["input"]>;
  scheduledStart?: InputMaybe<Scalars["Date"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  unregisteredGuests?: InputMaybe<Array<Scalars["String"]["input"]>>;
  visitorIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type UpdateScheduledMeetingResponse = {
  __typename: "UpdateScheduledMeetingResponse";
  meeting: Meeting;
};

export type UpdateStaffInput = {
  email: Scalars["String"]["input"];
  entitlements: Array<Entitlement>;
  facilityIds: Array<Scalars["ID"]["input"]>;
  firstName: Scalars["String"]["input"];
  lastName?: InputMaybe<Scalars["String"]["input"]>;
  phone?: InputMaybe<Scalars["String"]["input"]>;
  staffId: Scalars["ID"]["input"];
  systemId: Scalars["ID"]["input"];
};

export type UpdateStaffPreferencesInput = {
  receiveDailyScheduleEmails?: InputMaybe<Scalars["Boolean"]["input"]>;
  receiveFlaggedMessageEmails?: InputMaybe<Scalars["Boolean"]["input"]>;
  receiveTaskReminderEmails?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type UpdateStaffPreferencesResponse = {
  __typename: "UpdateStaffPreferencesResponse";
  staff: Staff;
};

export type UpdateStaffResponse = {
  __typename: "UpdateStaffResponse";
  staff: Staff;
};

export type UpdateSystemInput = {
  allowInmatePasswordReset?: InputMaybe<Scalars["Boolean"]["input"]>;
  dataRetention?: InputMaybe<Scalars["Int"]["input"]>;
  hasCallTranscripts?: InputMaybe<Scalars["Boolean"]["input"]>;
  hasTablets?: InputMaybe<Scalars["Boolean"]["input"]>;
  maxPasswordAgeDays?: InputMaybe<Scalars["Int"]["input"]>;
  recordingRetention?: InputMaybe<Scalars["Int"]["input"]>;
  systemId: Scalars["String"]["input"];
  visitorReapprovalDays?: InputMaybe<Scalars["Int"]["input"]>;
};

export type UpdateSystemResponse = {
  __typename: "UpdateSystemResponse";
  system: System;
};

export type UpdateVisitorEmailInput = {
  email: Scalars["String"]["input"];
  id: Scalars["ID"]["input"];
};

export type UpdateVisitorEmailResponse = {
  __typename: "UpdateVisitorEmailResponse";
  visitor: Visitor;
};

export type UpdateVisitorIdentityInput = {
  dateOfBirth: Scalars["String"]["input"];
  documentType?: InputMaybe<IdDocumentType>;
  firstName: Scalars["String"]["input"];
  imageOneKey?: InputMaybe<Scalars["String"]["input"]>;
  imageThreeKey?: InputMaybe<Scalars["String"]["input"]>;
  imageTwoKey?: InputMaybe<Scalars["String"]["input"]>;
  lastName?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpdateVisitorIdentityResponse = {
  __typename: "UpdateVisitorIdentityResponse";
  visitor: Visitor;
};

export type UpdateVisitorInput = {
  phone?: InputMaybe<Scalars["String"]["input"]>;
  visitorId: Scalars["ID"]["input"];
};

export type UpdateVisitorPstnNumberInput = {
  pstnNumber: Scalars["String"]["input"];
  systemVisitorId: Scalars["ID"]["input"];
};

export type UpdateVisitorPstnNumberResponse = {
  __typename: "UpdateVisitorPstnNumberResponse";
  visitor: Visitor;
};

export type UpdateVisitorResponse = {
  __typename: "UpdateVisitorResponse";
  visitor: Visitor;
};

export type UploadUrl = {
  __typename: "UploadUrl";
  key: Scalars["String"]["output"];
  url: Scalars["String"]["output"];
};

export type User = AmeelioStaff | Inmate | Staff | Visitor;

export enum UserType {
  Inmate = "INMATE",
  Staff = "STAFF",
  User = "USER",
}

export enum VirtualBackground {
  Optional = "OPTIONAL",
  Required = "REQUIRED",
  Unavailable = "UNAVAILABLE",
}

export type Visitor = Correspondent & {
  __typename: "Visitor";
  availableUploadTypes: Array<MessageType>;
  canReceiveVoiceCalls: Scalars["Boolean"]["output"];
  connection: Connection;
  connections: Array<Connection>;
  correspondentFeatures: Array<CorrespondentFeature>;
  dateOfBirth?: Maybe<Scalars["String"]["output"]>;
  /** @deprecated Use deviceRegistrationStatus */
  deviceNeedsRegistration: Scalars["Boolean"]["output"];
  deviceRegistrationStatus: DeviceRegistrationStatus;
  devices: Array<Device>;
  email: Scalars["String"]["output"];
  firstName: Scalars["String"]["output"];
  fullName: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  identity?: Maybe<VisitorIdentity>;
  initials: Scalars["String"]["output"];
  languagePreference: Language;
  lastName: Scalars["String"]["output"];
  malanId: Scalars["ID"]["output"];
  meetings: MeetingConnection;
  notificationEvents: NotificationEventConnection;
  organizationInvitation?: Maybe<OrganizationInvitation>;
  organizationMemberships: Array<OrganizationMembership>;
  phone?: Maybe<Scalars["String"]["output"]>;
  pstnNumber?: Maybe<Scalars["String"]["output"]>;
  surveyActivity: Array<Maybe<SurveyActivity>>;
  systemDevices: Array<SystemDevice>;
  systemRelationship?: Maybe<SystemUser>;
  systemRelationships: Array<SystemUser>;
  unavailableUntil?: Maybe<Scalars["Date"]["output"]>;
};

export type VisitorCanReceiveVoiceCallsArgs = {
  systemId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type VisitorConnectionArgs = {
  inmateId: Scalars["ID"]["input"];
};

export type VisitorConnectionsArgs = {
  facilityId?: InputMaybe<Scalars["ID"]["input"]>;
  organizationId?: InputMaybe<Scalars["ID"]["input"]>;
  organizationMembershipId?: InputMaybe<Scalars["ID"]["input"]>;
  systemId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type VisitorDeviceNeedsRegistrationArgs = {
  facilityId?: InputMaybe<Scalars["ID"]["input"]>;
  installationId: Scalars["String"]["input"];
};

export type VisitorDeviceRegistrationStatusArgs = {
  facilityId?: InputMaybe<Scalars["ID"]["input"]>;
  installationId: Scalars["String"]["input"];
};

export type VisitorMeetingsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  facilityId?: InputMaybe<Scalars["ID"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  meetingType?: InputMaybe<Array<MeetingType>>;
  scheduledEndAfter?: InputMaybe<Scalars["Date"]["input"]>;
  scheduledEndBefore?: InputMaybe<Scalars["Date"]["input"]>;
  scheduledStartAfter?: InputMaybe<Scalars["Date"]["input"]>;
  scheduledStartBefore?: InputMaybe<Scalars["Date"]["input"]>;
  status?: InputMaybe<Array<MeetingStatus>>;
};

export type VisitorNotificationEventsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type VisitorOrganizationMembershipsArgs = {
  status?: InputMaybe<Array<OrganizationMembershipStatus>>;
};

export type VisitorSystemRelationshipArgs = {
  systemId: Scalars["ID"]["input"];
};

export type VisitorConnection = {
  __typename: "VisitorConnection";
  count: Scalars["Int"]["output"];
  edges: Array<VisitorEdge>;
  pageInfo: PageInfo;
};

export type VisitorEdge = {
  __typename: "VisitorEdge";
  cursor: Scalars["String"]["output"];
  node: Visitor;
};

export type VisitorIdentity = {
  __typename: "VisitorIdentity";
  documentType: IdDocumentType;
  id: Scalars["ID"]["output"];
  idImageOneUrl?: Maybe<Scalars["String"]["output"]>;
  idImageThreeUrl?: Maybe<Scalars["String"]["output"]>;
  idImageTwoUrl?: Maybe<Scalars["String"]["output"]>;
  lastUploaded: Scalars["Date"]["output"];
  status: VisitorIdentityStatus;
};

export enum VisitorIdentityStatus {
  Approved = "APPROVED",
  Pending = "PENDING",
  Rejected = "REJECTED",
}

export type VisitorOrInmate = Inmate | Visitor;

export type VisitorOrInmateOrStaff = Inmate | Staff | Visitor;

export enum VisitorType {
  Personal = "PERSONAL",
  Professional = "PROFESSIONAL",
}

export type WebinarAvailability = {
  __typename: "WebinarAvailability";
  interval: Interval;
};

export type AppInfoResponse = {
  __typename: "appInfoResponse";
  mobileAppMinimumSupportedVersion: Scalars["String"]["output"];
  mobileAppVersion: Scalars["String"]["output"];
};
